<template>
  <page-outline :title="titleLabel" :icon="titleIcon" noReturn
    pageClass="rtp_details">
    <template slot="pageContent">
      <spinner v-if="!details.id || activateSpinner"></spinner>
      <div class="ml-3 mr-3" v-else>
        <b-row align-h="start">
          <b-col cols="4" sm="3" md="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
          <b-col cols="4" sm="3" md="2" xl="1"  @click="seeDetails()">
            <b-button class="back-button">
              <i class="fa-solid fa-rotate-right fs-14px"></i>
            </b-button>
          </b-col>
          <b-col v-if="canSeePaymentDetails && payments.length" cols="4" sm="3" md="2" xl="1">
            <b-button-group>
              <b-button class="rtpDetailsGroupBtn" :variant="tabName === 0 ? 'primary' : ''" @click="tabName = 0">{{ $t('common.request_to_pay_tab') }}</b-button>
              <b-button class="rtpDetailsGroupBtn" :variant="tabName === 1 ? 'primary' : ''" @click="tabName = 1">{{ $t('common.payment_tab') }}</b-button>
            </b-button-group>
          </b-col>
        </b-row>
        <br/>
        <b-tabs v-model="tabName" class="mt-3" nav-class="d-none">
          <!-- TAB RTP DETAILS -->
          <b-tab>
            <form-accordion :title="$t('attachments.doc_sent_list')" :isTitleUpperCase="false" v-if="details.Attachments && details.Attachments.length">
              <document-list :documents="details.Attachments"></document-list>
            </form-accordion>
            <form-accordion :title="$t('common.rqst_fr_gr')" :isTitleUpperCase="false"
              v-if="showOtherDebtors() && otherRTP.length > 1">
              <transactions-list
                filterBy="" itemListStyle="border-radius:0;"
                :actualMessageId="details.id"
                :messages="otherRTP"
                :randomId="randomId"
                :serviceId="services.PAYMENTS">
              </transactions-list>
            </form-accordion>

            <hr v-if="showOtherDebtors() && otherRTP.length > 1" class="mx-auto" />
            <form-accordion :title="$t('common.request_details')" :isTitleUpperCase="false">
              <b-row v-if="details.endToEndId || details.msgId || details.uri">
                <b-col xl="3" cols="3" class="form-group">
                  <form-read-group-label-input v-if="details.msgId"
                    :inputLabel="$t('filter.msgId')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="details.msgId"
                    labelClass="mb-0"
                    class="">
                  </form-read-group-label-input>
                </b-col>
                <b-col xl="3" cols="3" class="form-group">
                  <form-read-group-label-input v-if="details.endToEndId"
                    :inputLabel="$t('common.invc_ref')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="details.endToEndId"
                    labelClass="mb-0"
                    class="">
                  </form-read-group-label-input>
                </b-col>
                <b-col xl="3" cols="3" class="form-group" v-if="details.uri && details.uri.startsWith('REQ/ ')">
                  <form-read-group-label-input
                    :inputLabel="$t('common.uri')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    inputId="inputUri"
                    :inputValue="details.uri.substring(5, details.uri.length)"
                    labelClass="mb-0"
                    class="">
                    <div slot="afterInput" class="tooltip-info">
                      <i class="fa-duotone fa-file-text cursor text-info fs-20px ml-5px"
                        @click="copyToClipboard(details.uri.substring(5, details.uri.length))"
                        @mouseout="copyToClipboardReset()">
                        <span id="copyUri" class="tooltiptext">{{ $t('common.copy_to_clipboard') }}</span>
                      </i>
                    </div>
                  </form-read-group-label-input>
                </b-col>
                <b-col v-else xl="3" cols="3"></b-col>
              </b-row>
              <b-row>
                <b-col xl="3" cols="3" class="form-group" v-if="showAcceptModifyReason()">
                  <form-write-group-label-input :inputLabel="$t('common.rsn')" v-model="details.reason"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :maxLength="140"
                    labelClass="mb-0"
                    :tooltipLabel="$t('requestToPay.modify_reason_creditor')">
                  </form-write-group-label-input>
                </b-col>
                <b-col xl="3" cols="3" class="form-group" v-else-if="showAcceptModifyReasonValidated()">
                  <form-read-group-label-input :inputLabel="$t('common.rsn')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="details.acceptedRemittanceInformation"
                    labelClass="mb-0"
                    :tooltipLabel="concatenatedDateReasonText($t('common.rsn_ask'))">
                  </form-read-group-label-input>
                </b-col>
                <b-col xl="3" cols="3" class="form-group" v-else-if="showAcceptModifyReasonCreditor()">
                  <form-read-group-label-input :inputLabel="$t('common.rsn')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="details.acceptedRemittanceInformation ? details.acceptedRemittanceInformation : details.reason"
                    labelClass="mb-0"
                    :tooltipLabel="$t('requestToPay.modify_reason_debtor')">
                  </form-read-group-label-input>
                </b-col>
                <b-col xl="3" cols="3" class="form-group" v-else>
                  <form-read-group-label-input :inputLabel="$t('common.rsn')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="details.acceptedRemittanceInformation ? details.acceptedRemittanceInformation : details.reason"
                    labelClass="mb-0">
                  </form-read-group-label-input>
                </b-col>
                <b-col xl="3" cols="3" v-if="showAcceptModifyAmount()">
                  <form-write-group-label-input :inputLabel="$t('common.amnt_ttl_rtp')" :placeholderValue="$t('common.amnt_ttl_rtp') + ' ' + zoneCodeToSign()"
                    v-model="details.amount" isMandatory isNotZero
                    inputType="number"
                    :colLabelSize="4"
                    :colInputSize="8"
                    labelClass="mb-0"
                    :tooltipLabel="$t('requestToPay.modify_amount_creditor')"
                    :specificErrorIndicator="amountError"
                    :specificMessage="amountErrorMessage"
                    @blur="changeDebtorsAmount"
                    >
                  </form-write-group-label-input>
                </b-col>
                <b-col xl="3" cols="3" class="form-group" v-else-if="showAcceptModifyAmountValided()">
                  <form-read-group-label-input :inputLabel="$t('common.amnt_ttl_accept')"
                    :inputValue="details.acceptedAmount + ' ' + zoneCodeToSign()"
                    :colLabelSize="4"
                    :colInputSize="8"
                    labelClass="mb-0"
                    :tooltipLabel="concatenatedDateAmountText($t('common.amnt_ttl_ask')) + ' ' + zoneCodeToSign()">
                  </form-read-group-label-input>
                </b-col>
                <b-col xl="3" cols="3" class="form-group" v-else-if="showAcceptModifyAmountCreditor()">
                  <b-row class="align-items-end">
                    <b-col cols="11">
                      <form-read-group-label-input :inputLabel="$t('common.amnt_ttl')"
                        :inputValue="details.amount + ' ' + zoneCodeToSign()"
                        :colLabelSize="4"
                        :colInputSize="8"
                        labelClass="mb-0"
                        :tooltipLabel="$t('requestToPay.modify_amount_debtor')">
                      </form-read-group-label-input>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col xl="3" cols="3" class="form-group" v-else>
                  <form-read-group-label-input
                    :inputLabel="(details.installments.length ? $t('common.amnt_ttl') : (details.creditNoteAmount ? $t('common.amnt_crdt_nt') : $t('common.amnt_ttl')))"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="(details.creditNoteAmount ? details.creditNoteAmount : details.amount) + ' ' + zoneCodeToSign()"
                    labelClass="mb-0"
                    class="">
                  </form-read-group-label-input>
                </b-col>
                <b-col xl="3" cols="3" class="form-group">
                  <form-read-group-label-input :inputLabel="$t('common.status.status_label')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="getStatusLabel(details.status)"
                    labelClass="mb-0"
                    class=""
                    :tooltipLabel="getStatusReason(details.status)">
                  </form-read-group-label-input>
                </b-col>
                <b-col v-if="false" xl="3" cols="3"></b-col>
              </b-row>
              <b-row>
                <b-col xl="3" cols="3" class="form-group">
                  <form-read-group-label-input :inputLabel="$t('common.rqst_date')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="$options.filters.formatDateTime(details.dateTime)"
                    labelClass="mb-0">
                  </form-read-group-label-input>
                </b-col>
                <b-col xl="3" cols="3" class="form-group">
                  <form-read-group-label-input :inputLabel="$t('common.date_expr')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="$options.filters.formatDateTime(details.requestedExpirationDate)"
                    labelClass="mb-0">
                  </form-read-group-label-input>
                </b-col>
                <b-col xl="3" cols="3" class="form-group" v-if="showAcceptModifyDate() && !details.installments.length">
                  <datetime-picker-custom
                    v-model="requestedExecutionDateFormat" isMandatory disablePastDates
                    format="DD/MM/YYYY H:i:s"
                    customInputClass="form-control"
                    customLabelClass="mb-0"
                    :inputLabel="$t('common.exec_date')"
                    :maxLength="19"
                    :placeholderValue="$t('common.datetime_picker_empty_date')"
                    :tooltipLabel="$t('requestToPay.modify_date_creditor')"
                    inputIcon="fa-solid fa-calendar pl-2">
                    <i slot="afterInput"
                      v-if="hasPastExecutionDate && !details.installments.length"
                      class="fa-duotone fa-warning cursor text-warning fs-20px ml-5px"
                      :title="$t('common.exec_date_exprd')">
                    </i>
                  </datetime-picker-custom>
                </b-col>
                <b-col xl="3" cols="3" class="form-group" v-else-if="showAcceptModifyDateValidated()">
                  <form-read-group-label-input :inputLabel="$t('common.exec_date_accept')"
                    inputIcon="fa-solid fa-calendar text-info"
                    :inputValue="$options.filters.formatDateTime(details.acceptedRequestedExecutionDatetime)"
                    :colLabelSize="4"
                    :colInputSize="8"
                    inputType="date" disablePastDates
                    labelClass="mb-0"
                    :tooltipLabel="$t('common.exec_date_ask') + ' : ' + $options.filters.formatDateTime(details.requestedExecutionDate)">
                    <i slot="afterInput"
                      v-if="hasPastExecutionDate && !details.installments.length"
                      class="fa-duotone fa-warning cursor text-warning fs-17px ml-5px"
                      :title="$t('common.exec_date_exprd')">
                    </i>
                  </form-read-group-label-input>
                </b-col>
                <b-col xl="3" cols="3" class="form-group" v-else-if="showAcceptModifyDateCreditor() && !details.installments.length">
                  <form-read-group-label-input :inputLabel="$t('common.exec_date')"
                    inputIcon="fa-solid fa-calendar text-info"
                    :inputValue="$options.filters.formatDateTime(details.requestedExecutionDate)"
                    :colLabelSize="4"
                    :colInputSize="8"
                    inputType="date" disablePastDates
                    labelClass="mb-0"
                    :tooltipLabel="$t('requestToPay.modify_date_debtor')">
                    <i slot="afterInput"
                      v-if="hasPastExecutionDate && !details.installments.length"
                      class="fa-duotone fa-warning cursor text-warning fs-17px ml-5px"
                      :title="$t('common.exec_date_exprd')">
                    </i>
                  </form-read-group-label-input>
                </b-col>
                <b-col xl="3" cols="3" class="form-group" v-else-if="!details.installments.length">
                  <form-read-group-label-input :inputLabel="$t('common.exec_date')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="$options.filters.formatDateTime(details.requestedExecutionDate)"
                    labelClass="mb-0">
                    <i slot="afterInput"
                      v-if="hasPastExecutionDate && !details.installments.length"
                      class="fa-duotone fa-warning cursor text-warning fs-17px ml-5px"
                      :title="$t('common.exec_date_exprd')">
                    </i>
                  </form-read-group-label-input>
                </b-col>
                <b-col cols="3" class="form-group" v-else>
                </b-col>
              </b-row>
              <b-row v-if="details.paymentRequest">
                <b-col cols="3" class="form-group" v-if="details.paymentRequest.debtorIban">
                  <form-read-group-label-input :inputLabel="$t('common.debtor_ibn_used')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="details.paymentRequest.debtorIban"
                    labelClass="mb-0"
                    class="">
                  </form-read-group-label-input>
                </b-col>
                <b-col cols="3" class="form-group" v-if="details.paymentRequest.status">
                  <form-read-group-label-input :inputLabel="$t('common.payment_status')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="$t('common.status.payment.' + details.paymentRequest.status)"
                    labelClass="mb-0"
                    class="">
                  </form-read-group-label-input>
                </b-col>
                <b-col cols="3" v-if="canSeePain001">
                  <form-read-group-label-input :inputLabel="$t('common.flux_out')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="details.paymentRequest.format.out.type"
                    labelClass="mb-0"
                    class="">
                  </form-read-group-label-input>
                  <div>
                    <i class="fa fa-eye cursor pl-2 pr-1 color-var-actionButtonColorBlue" @click="seeXml(details.paymentRequest.format.out, 'payment', 'see')"></i>
                    <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(details.paymentRequest.format.out, 'payment', 'download')"></i>
                  </div>
                </b-col>
                <b-col xl="3" cols="3" class="form-group" v-if="details.paymentRequest === '1' && this.receivedPayments && this.receivedPayments.length <= 1" >
                </b-col>
                <b-col xl="3" cols="3" class="form-group">
                  <form-read-group-label-input v-if="details.paymentRequest === '1' && this.receivedPayments && this.receivedPayments.length <= 1 && payments.length"
                    :inputLabel="$t('administration.transaction_identifier')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="payments[0].TransactionId ? payments[0].TransactionId : '-'"
                    labelClass="mb-0"
                    class="">
                  </form-read-group-label-input>
                </b-col>
                <b-col cols="3" class="form-group" v-if="details.paymentRequest === '1' && this.receivedPayments && this.receivedPayments.length <= 1 && payments.length">
                  <form-read-group-label-input :inputLabel="$t('common.payment_status')"
                    :colLabelSize="4"
                    :colInputSize="8"
                    :inputValue="$t('common.status.payment.' + payments[0].status)"
                    labelClass="mb-0"
                    class="">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <!-- INSTALLMENTS -->
            <form-accordion v-if="details.installments.length" :title="$t('common.request_installments_proposed')" :isTitleUpperCase="false" :key="installmentRefresh">
              <b-table hover responsive
                v-if="details.installments.length"
                class="table-condensed"
                :class="!canSeePaymentDetails || (this.receivedPayments && this.receivedPayments.length <= 1) ? 'w-50' : 'px-5'"
                :key="keyTableInstallments"
                :items="details.installments"
                :fields="installmentsFields"
                select-mode="single">
                <template #cell(Number)="data">
                  <span>{{ data.index + 1 }}</span>
                </template>
                <template #cell(Date)="data">
                  <div v-if="showAcceptModifyDate()" class="d-flex justify-content-center align-items-center">
                    <datetime-picker-custom
                      :value="formateInstalmentDate(data.value)" isMandatory disablePastDates
                      format="DD/MM/YYYY H:i:s"
                      customInputClass="form-control"
                      customLabelClass="mb-0"
                      :maxLength="19"
                      :placeholderValue="$t('common.datetime_picker_empty_date')"
                      :tooltipLabel="$t('requestToPay.modify_date_creditor')"
                      inputIcon="fa-solid fa-calendar pl-2"
                      @blur="changeDebtorsDate"
                      @input="changeInstallementDates($event, data.index)">
                    </datetime-picker-custom>
                    <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('requestToPay.modify_date_creditor')"></i>
                  </div>
                  <div v-else-if="showAcceptModifyDateCreditor()">
                    <span>{{ $options.filters.formatDateTime(details.installments[data.index].Date) }}</span>
                    <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('requestToPay.modify_field_quotes_debtor', {field: $t('common.exec_date') + ' ' + (data.index + 1)})"></i>
                  </div>
                  <div v-else-if="showAcceptModifyInstallmentValidated()">
                    <span>{{ $options.filters.formatDateTime(details.installments[data.index].Date) }}</span>
                    <i v-if="details.originalInstallments[data.index].Date" class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.exec_date_ask') + ' : ' +  $options.filters.formatDateTime(details.originalInstallments[data.index].Date)"></i>
                  </div>
                  <span v-else>{{ $options.filters.formatDateTime(details.installments[data.index].Date) }}</span>
                  <div v-if="hasPastExecutionDateInstalment(data.item)" class="text-warning font-weight-bold">
                    <small><i class="fa-duotone fa-warning cursor"></i>{{ $t('common.exec_date_exprd') }}</small>
                  </div>
                </template>
                <template #cell(Amount)="data">
                  <div v-if="showAcceptModifyAmount()" class="d-flex justify-content-center align-items-center">
                    <form-write-group-label-input v-if="showAcceptModifyAmount()" isMandatory disablePastDates
                      :placeholderValue="$t('common.amnt_installment_rtp') + ' ' + (data.index + 1) + ' ' + zoneCodeToSign()"
                      inputType="number"
                      :colLabelSize="4"
                      :colInputSize="8"
                      :minValue="0"
                      :value="data.value"
                      @input="changeInstallementAmounts($event, data.index)"
                      labelClass="mb-0"
                      class=""
                      :tooltipLabel="$t('requestToPay.modify_amount_creditor')"
                      @blur="changeDebtorsAmount"
                      >
                    </form-write-group-label-input>
                    <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('requestToPay.modify_amount_creditor')"></i>
                  </div>
                  <div v-else-if="showAcceptModifyAmountCreditor()">
                    <span>{{ details.installments[data.index].Amount + ' ' + zoneCodeToSign() }}</span>
                    <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('requestToPay.modify_field_quotes_debtor', {field: $t('common.amnt_installment_rtp') + ' ' + (data.index + 1)})"></i>
                  </div>
                  <div v-else-if="showAcceptModifyInstallmentValidated()">
                    <span>{{ details.installments[data.index].Amount + ' ' + zoneCodeToSign() }}</span>
                    <i v-if="details.originalInstallments[data.index].Amount" class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.amnt_installment_rtp_ask') + ' : ' + details.originalInstallments[data.index].Amount  + ' ' + zoneCodeToSign()"></i>
                  </div>
                  <span v-else>{{ details.installments[data.index].Amount + ' ' + zoneCodeToSign() }}</span>
                </template>
                <template #cell(TransactionId)="data">
                  <span>{{ data.value ? data.value : "-" }}</span>
                </template>
                <template #cell(Status)="data">
                  <span>{{ data.value ? $t('common.status.payment.' + data.value) : "-" }}</span>
                </template>
              </b-table>
            </form-accordion>

            <hr class="mx-auto" />

            <!-- details.direction === '1' && details.creditorIdentifier === userIdentifier ? $t('Mes informations') -->
            <form-accordion :title="$t('creation_forms.crdtr_info')" :isTitleUpperCase="false">
              <b-row class="pt-1 mb-3">
                <template>
                  <b-col xl="3" cols="3" class="form-group">
                    <form-read-group-label-input :inputLabel="$t('common.my_nme')"
                      :inputValue="details.creditorName"
                      labelClass="mb-0">
                    </form-read-group-label-input>
                  </b-col>
                </template>
                <b-col xl="3" cols="3" class="form-group">
                  <form-read-group-label-input :inputLabel="$t('common.rtp_dbtr_ibn')"
                    :inputValue="details.creditorBankAccount"
                    labelClass="mb-0"
                    class="">
                  </form-read-group-label-input>
                </b-col>
                <b-col xl="3" cols="3" class="form-group">
                  <form-read-group-label-input
                    :inputLabel="$t('common.my_provider')"
                    :inputValue="details.creditorBIC"
                    labelClass="mb-0">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>

              <hr class="mx-auto" />

              <!-- TLV 25/09/2020 / supprime : On affiche le nom et l'e-mail du créancier si c'est le débiteur
              (le destinataire de la RTP) qui regarde. Si le créancier (l'expéditeur de la RTP)
              regarde, on affiche le nom et l'e-mail du débiteur
              details.direction === '1' ? $t('Informations du débiteur') : $t('Mes informations') -->
              <form-accordion :title="$t('creation_forms.dbtr_info')" :isTitleUpperCase="false">
                <b-row class="pt-1 mb-3">
                  <b-col xl="3" cols="3" class="form-group">
                    <form-read-group-label-input :inputLabel="$t('common.my_nme')"
                      :inputValue="details.debtorName"
                      labelClass="mb-0"
                      class="">
                    </form-read-group-label-input>
                  </b-col>
                  <b-col xl="3" cols="3" class="form-group">
                    <form-read-group-label-input :inputLabel="$t('common.rtp_dbtr_ibn')"
                      :inputValue="details.debtorBankAccount ? details.debtorBankAccount : '-'"
                      labelClass="mb-0"
                      class="">
                    </form-read-group-label-input>
                  </b-col>
                  <b-col xl="3" cols="3" class="form-group">
                    <form-read-group-label-input :inputLabel="$t('common.rtp_dbtr_provider')"
                      :inputValue="details.debtorIdProvider"
                      labelClass="mb-0"
                      class="">
                    </form-read-group-label-input>
                  </b-col>
                </b-row>
                <!-- <b-row class="pt-1 mb-3">
                  <b-col xl="3" cols="3" class="form-group">
                    <form-read-group-label-input :inputLabel="$t('common.recipient_srtp_id_company')"
                      :inputValue="details.debtorIdCompany"
                      labelClass="mb-0"
                      class="">
                    </form-read-group-label-input>
                  </b-col>
                </b-row> -->
                <!--<b-row>
                  <b-col v-if="isUserDebtor && isDebtorBankAccountAvailable" xl="3" cols="3">
                    <select-bank-account v-model="debtorBankAccount" :disabled="!isDebtorBankAccountEditable" :default="false"
                      labelClass="text-decoration-underline-hover mb-0"
                      inputClass="d-flex align-items-center icon-input bank-account-icon"
                      inputIcon="fa-solid fa-building-columns text-info">
                    </select-bank-account>
                  </b-col>
                </b-row>-->
              </form-accordion>

              <!--<b-row class="panel-subtitle mb-3">
                <b-col sm="6" class="form-group">
                  <form-read-group-label-input :inputLabel="$t('common.rqst_date')" horizontal
                    :inputValue="details.creationDate | formatDate"
                    labelClass="mb-0"
                    class="panel-subtitle-detail-demande-form">
                  </form-read-group-label-input>
                </b-col>
              </b-row>-->

              <!--<b-row class="panel-subtitle mb-3">
                <b-col sm="6" class="form-group" v-if="details.direction === '0' && details.acceptModifyExecutionDate === '1'">
                  <form-write-group-label-input v-model="details.requestedExecutionDate" isMandatory
                    inputType="date" disablePastDates :disableFromDate="oldDate"
                    :inputLabel="$t('common.exec_date')" horizontal
                    labelClass="mb-0"
                    class="panel-subtitle-detail-demande-form">
                  </form-write-group-label-input>
                </b-col>
                <b-col sm="6" class="form-group" v-else>
                  <form-read-group-label-input :inputLabel="$t('common.exec_date')" horizontal
                    :inputValue="details.requestedExecutionDate | formatDate"
                    labelClass="mb-0"
                    class="panel-subtitle-detail-demande-form">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="6" class="form-group">
                  <form-read-group-label-input :inputLabel="$t('common.other_id')" horizontal
                    inputValue="FA14159265"
                    labelClass="mb-0"
                    class="panel-subtitle-detail-demande-form">
                  </form-read-group-label-input>
                </b-col>
              </b-row>-->

              <!--<b-row class="panel-subtitle" v-if="waitingForAnswerRTP(details.status)">
                <b-col sm="6" class="form-group" v-if="details.direction === '0' && details.acceptModifyAmount === '1'">
                  <form-write-group-label-input v-model="details.amount" isMandatory
                    inputType="number"
                    :inputLabel="$t('common.amnt')" horizontal
                    :placeholderValue="$t('common.amnt')"
                    labelClass="mb-0"
                    class="panel-subtitle-detail-demande-form">
                  </form-write-group-label-input>
                </b-col>
                <b-col sm="6" class="form-group" v-else>
                  <form-read-group-label-input :inputLabel="$t('common.amnt')" horizontal
                    :inputValue="details.amount + ' ' + getCurrencyIcon(details.currency)"
                    labelClass="mb-0"
                    class="panel-subtitle-detail-demande-form">
                  </form-read-group-label-input>
                </b-col>
              </b-row>-->

              <!--<b-row class="panel-subtitle" v-else>
                <b-col sm="6" class="form-group" v-if="details.amountResponse.length > 0">
                  <form-read-group-label-input :inputLabel="$t('common.amnt')" horizontal
                    :inputValue="details.amountResponse + ' ' + getCurrencyIcon(details.currency)"
                    labelClass="mb-0"
                    class="panel-subtitle-detail-demande-form">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="6" class="form-group" v-else>
                  <form-read-group-label-input :inputLabel="$t('common.amnt')" horizontal
                    :inputValue="details.amount + ' ' + getCurrencyIcon(details.currency)"
                    labelClass="mb-0"
                    class="panel-subtitle-detail-demande-form">
                  </form-read-group-label-input>
                </b-col>
              </b-row>-->

              <b-row class="panel-subtitle d-none" v-if="details.direction === '0'">
                <b-col class="form-group">
                  <b-form-checkbox v-model="details.instantPayment"
                    v-if="showInstantPayment(details.debtorBankAccount)"
                    class="mt-sm-2" value="1" unchecked-value="0"
                    :disabled="!waitingForAnswerRTP(details.status) || isInstantPayment">
                    {{ $t('requestToPay.is_inst_payment') }}
                    {{ '(' + getBankName(details.debtorBankAccount) + ')' }}
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <div v-if="(waitingForAnswerRTP(details.status) && details.negotStatus === '10') ||
                (waitingForAnswerRTP(details.status) && details.negotStatus === '11') ||
                details.status === status.ACCEPTED ||
                details.status === status.MODIFIED ||
                details.status === status.REVOKED ||
                details.status === status.ACCEPTED_AND_PAYED ||
                details.status === status.ACCEPTED_AND_PAYED_INST ||
                details.status === status.MODIFIED_AND_PAYED ||
                details.status === status.MODIFIED_AND_PAYED_INST ||
                details.status === status.ORDER_GENERATED ||
                details.status === status.MADE ||
                details.status === status.INST_MADE">
                <!-- TLV 13/09/2020 Affichage de l'historique du montant et de la date d'exécution, s'il a lieu d'être -->
                <div v-if="((details.amountResponse.length > 0 && details.amountResponse !== details.amount) ||
                  (details.executionDateResponse.length > 0 && details.requestedExecutionDate !== details.executionDateResponse))">
                  <b-row class="form-group">
                    <b-col class="transactionDetailSubHeader">
                      {{ $t('common.orig_terms') }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6" class="form-group"
                      v-if="details.amountResponse.length > 0 && details.amountResponse !== details.amount">
                      <form-read-group-label-input :inputLabel="$t('common.orig_amount')" horizontal
                        :inputValue="details.amount + ' ' + zoneCodeToSign()"
                        labelClass="mb-0"
                        class="panel-subtitle-detail-demande-form">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="6" class="form-group"
                      v-if="details.executionDateResponse.length > 0 && details.requestedExecutionDate !== details.executionDateResponse">
                      <form-read-group-label-input :inputLabel="$t('common.exec_date_orig')" horizontal
                        :inputValue="details.requestedExecutionDate | formatDate"
                        labelClass="mb-0"
                        class="panel-subtitle-detail-demande-form">
                      </form-read-group-label-input>
                    </b-col>
                  </b-row>
                </div>
              </div>

              <!-- ============================== -->
              <!--          INSTALLMENTS          -->
              <!-- ============================== -->

              <b-row class="mt-2" v-if="false && (details.Attachments && details.Attachments.length > 0) || details.lettrage">
                <b-col sm="6" class="form-group" v-if="details.lettrage">
                  <b-row>
                    <b-col cols="12" class="transactionDetailSubHeader">
                      {{ "Lettrage" }}
                    </b-col>
                    <b-col cols="12" class="mt-2">
                      {{ details.lettrage && details.lettrage.length > 0 ? formatLettrage(details.lettrage) : 'Pas de lettrage' }}
                    </b-col>
                  </b-row>
                </b-col>
                <b-col sm="6" class="form-group" v-if="details.Attachments && details.Attachments.length > 0">
                  <b-row>
                    <b-col cols="12" class="transactionDetailSubHeader">
                      {{ "Document" }}
                    </b-col>
                  </b-row>
                  <document-list :documents="details.Attachments"></document-list>
                </b-col>
              </b-row>

            <hr v-if="details.status === status.REVOKED" class="mx-auto"/>

            <form-accordion :title="$t('common.formsSubTitle.refuse_reason')" font-size="1rem"
              v-if="details.status === status.REVOKED">
              <b-row>
                <b-col>
                  <p>{{ details.decisionMessage }}</p>
                </b-col>
              </b-row>
            </form-accordion>

            <hr v-if="details.cancelMessage && details.cancelMessage !== ''" class="mx-auto"/>

            <form-accordion :title="$t('common.formsSubTitle.cancel_reason')" font-size="1rem"
              v-if="details.cancelCode && details.cancelCode !== ''">
              <b-row>
                <b-col>
                  <p><b>{{ $t(getCancelCodeLabel(details.cancelCode)) }}</b></p>
                  <p v-if="details.cancelMessage && details.cancelMessage !== ''">{{ details.cancelMessage }}</p>
                </b-col>
              </b-row>
            </form-accordion>

            <hr v-if="details.direction === '0' && waitingForAnswerRTP(details.status) && details.acceptMultipleInstalments === '1'" class="mx-auto" />

            <form-accordion :title="'ECHEANCIER'" font-size="1rem"
              v-if="details.direction === '0' && waitingForAnswerRTP(details.status) && details.acceptMultipleInstalments === '1'">
              <b-row>
                <b-col>
                  <b-form-checkbox v-model="showInstallments"
                    class="mt-sm-2"
                    :value="true" :unchecked-value="false">
                    {{ $t('common.ask_multiple_payments_times') }}
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <br/>
              <b-row v-if="showInstallments">
                <b-col sm="6" class="form-group">
                  <form-write-group-label-input v-model="numInstallments"
                    inputType="number"
                    inputLabel="Nombre d'échéances">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row v-if="showInstallments">
                <b-col>
                  <echeancier v-model="multPmts"
                    :numPay="numInstallments" :min="1"
                    :amount="details.amount" ccy="€" :deposit="0"
                    :execDate="details.requestedExecutionDate">
                  </echeancier>
                </b-col>
              </b-row>
            </form-accordion>

            <hr class="mx-auto" />

            <form-accordion :title="$t('common.formsSubTitle.rqst_to_pay_hstry')" :open="true" :isTitleUpperCase="false">
              <b-row class="form-group">
                <b-col>
                  <table class="table text-center">
                    <thead>
                      <tr>
                        <th>
                          {{ $t('common.date_request_label') }}
                        </th>
                        <th>
                          {{ $t('common.status.status_label') }}
                        </th>
                        <th v-if="fileFormat && hasRight('xmlDetail_consulter')">
                          {{ $t('requestToPay.stream_in')}}
                        </th>
                        <th v-if="fileFormat && hasRight('xmlDetail_consulter')">
                          {{ $t('requestToPay.stream_out')}}
                        </th>
                        <th>
                          {{ $t('requestToPay.stream_out_status')}}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="record in details.history" :key="record.id">
                        <td v-if="(record.status !== '20' && isHRTP) || isSRTP || isPSD2">
                          {{ $options.filters.formatDateTime(record.creationDate) }}
                        </td>
                        <td v-if="(record.status !== '20' && isHRTP) || isSRTP || isPSD2">
                          {{getHistoryLabel(record.status)}}
                        </td>
                        <td v-if="(fileFormat && hasRight('xmlDetail_consulter')) && ((record.status !== '20' && isHRTP) || isSRTP || isPSD2)">
                          <div v-if="!canSeeFormatIn(record)">-</div>
                          <div v-else class="d-xl-flex align-items-center justify-content-center">
                            {{record.format.in.type}}
                            <div>
                              <i class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.in, 'requestToPay', 'see')"></i>
                              <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.in, 'requestToPay', 'download')"></i>
                            </div>
                          </div>
                        </td>
                        <td v-if="(fileFormat && hasRight('xmlDetail_consulter')) && ((record.status !== '20' && isHRTP) || isSRTP || isPSD2)">
                          <div v-if="!canSeeFormatOut(record)">-</div>
                          <div v-else class="d-xl-flex align-items-center justify-content-center">
                            {{record.format.out.type}}
                            <div>
                              <i class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'requestToPay', 'see')"></i>
                              <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'requestToPay', 'download')"></i>
                            </div>
                          </div>
                        </td>
                        <td v-if="((record.status !== '20' && isHRTP) || isSRTP || isPSD2)">
                          <div v-if="record.format.out.technicalCode === TECHNICAL_CODE.OK">
                            <span>{{ record.format.out.technicalDescription }}</span>
                            <i class="fa fa-check px-2 color-var-actionButtonColorBlue"></i>
                            <i v-if="canSeeErrorBody(record)" class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'requestToPay', 'see', record.id)"></i>
                            <i v-if="canSeeErrorBody(record)" class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'requestToPay', 'download', record.id)"></i>
                          </div>
                          <div v-else-if="record.format.out.technicalCode === TECHNICAL_CODE.KO">
                            <span>{{ record.format.out.technicalDescription }}</span>
                            <i class="fa fa-xmark px-2 color-red"></i>
                            <i v-if="canSeeErrorBody(record)" class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'requestToPay', 'see', record.id)"></i>
                            <i v-if="canSeeErrorBody(record)" class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'requestToPay', 'download', record.id)"></i>
                          </div>
                          <div v-else-if="record.format.out.technicalCode === TECHNICAL_CODE.NO_ANSWER">
                            <span>{{ record.format.out.technicalDescription }}</span>
                            <i class="fa-solid fa-plug-circle-xmark px-2 redIcon"></i>
                          </div>
                          <div v-else>-</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
            </form-accordion>
          </b-tab>
          <!-- TAB PAYMENT DETAILS -->
          <b-tab>
            <f7-list v-if="canSeePaymentDetails && payments.length > 1">
              <f7-list-item :class="{'filter-item-section':true}">
                <b-row class="min-w-100 justify-content-start">
                  <div class="filter-item col-3 mb-1">
                    <span class="filter-item-title text-ellipsis">{{ $t('administration.transaction_identifier') }}</span>
                    <span class="filter-item-content">
                      <input v-model="transactionIdFilter" @input="delayApplyFilter()"
                        type="text"
                        :class="{'filter-item-input': true, 'filter-item-input-complete': transactionIdFilter}"
                        :placeholder="$t('administration.transaction_identifier')">
                      </input>
                    </span>
                  </div>
                  <div class="filter-item col-3 mb-1">
                    <span class="filter-item-title text-ellipsis">{{ $t('common.amnt_installment_rtp') }}</span>
                    <span class="filter-item-content">
                      <input v-model="amountFilter" @input="delayApplyFilter()"
                        type="text"
                        :class="{'filter-item-input': true, 'filter-item-input-complete': amountFilter}"
                        :placeholder="$t('common.amnt_installment_rtp')">
                      </input>
                    </span>
                  </div>
                  <div class="filter-item col-3 mb-1">
                    <span class="filter-item-title text-ellipsis">
                      {{ $t('common.status.payment_status_label') }}
                    </span>
                    <a :id="'status-payment-picker-link' + '-' + randomStringStatusFilter" class="filter-item-content d-flex justify-content-between p-1 pt-2"
                      href="#">
                      <span :class="'fixed-span-size ' + (statusDisplay.nb > 0 ? 'filter-item-input-complete' : '')">{{ statusDisplay.label }}</span>
                      <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"></i>
                    </a>
                    <b-popover :target="'status-payment-picker-link' + '-' + randomStringStatusFilter"
                      :title="$t('filter.selected_status_none')"
                      triggers="focus" placement="bottom">
                      <div>
                        <span v-for="(status, index) in statusList" :key="$t('common.status.payment.' + status.id) + '-' + index">
                          <b-form-checkbox v-model="status.state"
                            v-if="arrayStatusListPayment.includes(status.id)" @input="delayApplyFilter()"
                            :value="1"
                            :unchecked-value="0">
                            <span class="font-weight-normal fs-13px">{{ $t('common.status.payment.' + status.id) }}</span>
                          </b-form-checkbox>
                        </span>
                      </div>
                    </b-popover>
                  </div>
                  <div class="d-flex justify-content-between flex-row filter-item col-3 mt-4 mb-1 p-0">
                    <b-button size="sm"
                      @click="clearFilterFields"
                      :disabled="!hasInputFilter">
                      {{ $t('filter.clr_fltr_field') }}
                    </b-button>
                    <b-button size="sm" class="ml-1"
                      @click="applyFilter()">
                      {{ $t('filter.fltr') }}
                    </b-button>
                  </div>
                </b-row>
              </f7-list-item>
            </f7-list>
            <div v-if="payments.length <= 1 && canSeePaymentDetails && !noPaymentsFiltered">
              <form-accordion class="px-2"  v-if="payments.length" :title="$t('common.request_details')" :isTitleUpperCase="false">
                <b-row v-if="payments.length">
                  <b-col xl="3" cols="3" class="form-group">
                    <form-read-group-label-input
                      :inputLabel="$t('administration.message_identifier')"
                      :colLabelSize="4"
                      :colInputSize="8"
                      :inputValue="payments[0].msgId"
                      labelClass="mb-0"
                      class="">
                    </form-read-group-label-input>
                  </b-col>
                  <b-col xl="3" cols="3" class="form-group">
                    <form-read-group-label-input
                      :inputLabel="$t('administration.transaction_identifier')"
                      :colLabelSize="4"
                      :colInputSize="8"
                      :inputValue="payments.length && payments[0].TransactionId ? payments[0].TransactionId : '-'"
                      labelClass="mb-0"
                      class="">
                    </form-read-group-label-input>
                  </b-col>
                  <b-col xl="3" cols="3" class="form-group">
                    <form-read-group-label-input
                      :inputLabel="$t('common.status.payment_status_label')"
                      :colLabelSize="4"
                      :colInputSize="8"
                      :inputValue="payments.length ? getStatusLabel(payments[0].status) : '-'"
                      labelClass="mb-0"
                      class="">
                    </form-read-group-label-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xl="3" cols="3" class="form-group">
                    <form-read-group-label-input
                      :inputLabel="$t('common.exec_date')"
                      :colLabelSize="4"
                      :colInputSize="8"
                      :inputValue="$options.filters.formatDateTime(payments[0].executionDate)"
                      labelClass="mb-0"
                      class="">
                    </form-read-group-label-input>
                  </b-col>
                  <b-col xl="3" cols="3" class="form-group">
                    <form-read-group-label-input
                      :inputLabel="$t('common.amnt')"
                      :colLabelSize="4"
                      :colInputSize="8"
                      :inputValue="payments[0].amount + ' ' + zoneCodeToSign()"
                      labelClass="mb-0"
                      class="">
                    </form-read-group-label-input>
                  </b-col>
                  <b-col xl="3" cols="3" class="form-group">
                    <form-read-group-label-input
                      :inputLabel="$t('common.debtor_ibn_used')"
                      :colLabelSize="4"
                      :colInputSize="8"
                      :inputValue="payments[0].debtorBankAccount"
                      labelClass="mb-0"
                      class="">
                    </form-read-group-label-input>
                  </b-col>
                </b-row>
              </form-accordion>
              <form-accordion class="px-2" v-if="payments.length" :title="$t('common.formsSubTitle.rqst_to_pay_hstry')" :open="true" :isTitleUpperCase="false">
                <b-row class="form-group">
                  <b-col>
                    <table class="table text-center">
                      <thead>
                        <tr>
                          <th>
                            {{ $t('common.date_request_label') }}
                          </th>
                          <th>
                            {{ $t('common.status.payment_status_label') }}
                          </th>
                          <th v-if="fileFormat && hasRight('xmlDetail_consulter')">
                            {{ $t('requestToPay.stream_in')}}
                          </th>
                          <th v-if="fileFormat && hasRight('xmlDetail_consulter')">
                            {{ $t('requestToPay.stream_out')}}
                          </th>
                          <th>
                            {{ $t('requestToPay.stream_out_status')}}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="record in payments[0].history" :key="record.id">
                          <td v-if="(record.status !== '20' && isHRTP) || isSRTP || isPSD2">
                            {{ $options.filters.formatDateTime(record.creationDate) }}
                          </td>
                          <td v-if="(record.status !== '20' && isHRTP) || isSRTP || isPSD2">
                            {{ getHistoryLabel(record.status) }}
                          </td>
                          <td v-if="(fileFormat && hasRight('xmlDetail_consulter')) && ((record.status !== '20' && isHRTP) || isSRTP || isPSD2)">
                            <div v-if="!canSeeFormatIn(record)">-</div>
                            <div v-else class="d-xl-flex align-items-center justify-content-center">
                              {{record.format.in.type}}
                              <div>
                                <i class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.in, 'payment', 'see')"></i>
                                <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.in, 'payment', 'download')"></i>
                              </div>
                            </div>
                          </td>
                          <td v-if="(fileFormat && hasRight('xmlDetail_consulter')) && ((record.status !== '20' && isHRTP) || isSRTP || isPSD2)">
                            <div v-if="!canSeeFormatOut(record)">-</div>
                            <div v-else class="d-xl-flex align-items-center justify-content-center">
                              {{record.format.out.type}}
                              <div>
                                <i class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'payment', 'see')"></i>
                                <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'payment', 'download')"></i>
                              </div>
                            </div>
                          </td>
                          <td v-if="((record.status !== '20' && isHRTP) || isSRTP || isPSD2)">
                            <div v-if="record.format.out.technicalCode === TECHNICAL_CODE.OK">
                              <span>{{ record.format.out.technicalDescription }}</span>
                              <i class="fa fa-check px-2 color-var-actionButtonColorBlue"></i>
                              <i v-if="canSeeErrorBody(record)" class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'payment', 'see', record.id)"></i>
                              <i v-if="canSeeErrorBody(record)" class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'payment', 'download', record.id)"></i>
                            </div>
                            <div v-else-if="record.format.out.technicalCode === TECHNICAL_CODE.KO">
                              <span>{{ record.format.out.technicalDescription }}</span>
                              <i class="fa fa-xmark px-2 color-red"></i>
                              <i v-if="canSeeErrorBody(record)" class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'payment', 'see', record.id)"></i>
                              <i v-if="canSeeErrorBody(record)" class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'payment', 'download', record.id)"></i>
                            </div>
                            <div v-else-if="record.format.out.technicalCode === TECHNICAL_CODE.NO_ANSWER">
                              <span>{{ record.format.out.technicalDescription }}</span>
                              <i class="fa-solid fa-plug-circle-xmark px-2 redIcon"></i>
                            </div>
                            <div v-else>-</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </form-accordion>
            </div>
            <div v-else-if="canSeePaymentDetails && !noPaymentsFiltered" class="panel-reverse-margin">
              <div v-for="(payment, index) in payments" :key="payment.id" class="counter-panel-reverse-margin" :class="getBgColor(index)">
                <form-accordion v-if="Object.keys(payment).length > 0" class="py-3" :title="$t('common.payment') + ' ' + (index + 1)" :isTitleUpperCase="false">
                  <div class="px-2">
                    <span class="form-group titleAccordion font-weight-bold">{{ $t('common.request_details') }}</span>
                    <b-row class="mt-3">
                      <b-col xl="3" cols="3" class="form-group">
                        <form-read-group-label-input
                          :inputLabel="$t('administration.message_identifier')"
                          :colLabelSize="4"
                          :colInputSize="8"
                          :inputValue="payment.msgId"
                          labelClass="mb-0"
                          class="">
                        </form-read-group-label-input>
                      </b-col>
                      <b-col xl="3" cols="3" class="form-group">
                        <form-read-group-label-input
                          :inputLabel="$t('administration.transaction_identifier')"
                          :colLabelSize="4"
                          :colInputSize="8"
                          :inputValue="payment.TransactionId === '' ? '-' : payment.TransactionId"
                          labelClass="mb-0"
                          class="">
                        </form-read-group-label-input>
                      </b-col>
                      <b-col xl="3" cols="3" class="form-group">
                        <form-read-group-label-input
                          :inputLabel="$t('common.status.payment_status_label')"
                          :colLabelSize="4"
                          :colInputSize="8"
                          :inputValue="getStatusLabel(payment.status)"
                          labelClass="mb-0"
                          class="">
                        </form-read-group-label-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col xl="3" cols="3" class="form-group">
                        <form-read-group-label-input
                          :inputLabel="$t('common.exec_date')"
                          :colLabelSize="4"
                          :colInputSize="8"
                          :inputValue="$options.filters.formatDateTime(payment.executionDate)"
                          labelClass="mb-0"
                          class="">
                        </form-read-group-label-input>
                      </b-col>
                      <b-col xl="3" cols="3" class="form-group">
                        <form-read-group-label-input
                          :inputLabel="$t('common.amnt')"
                          :colLabelSize="4"
                          :colInputSize="8"
                          :inputValue="payment.amount + ' ' + zoneCodeToSign()"
                          labelClass="mb-0"
                          class="">
                        </form-read-group-label-input>
                      </b-col>
                      <b-col xl="3" cols="3" class="form-group">
                        <form-read-group-label-input
                          :inputLabel="$t('common.debtor_ibn_used')"
                          :colLabelSize="4"
                          :colInputSize="8"
                          :inputValue="payment.debtorBankAccount"
                          labelClass="mb-0"
                          class="">
                        </form-read-group-label-input>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="px-2">
                    <span class="form-group titleAccordion font-weight-bold">{{ $t('common.formsSubTitle.rqst_to_pay_hstry') }}</span>
                    <b-row class="mt-3 form-group">
                      <b-col>
                        <table class="table text-center">
                          <thead>
                            <tr>
                              <th>
                                {{ $t('common.date_request_label') }}
                              </th>
                              <th>
                                {{ $t('common.status.payment_status_label') }}
                              </th>
                              <th v-if="fileFormat && hasRight('xmlDetail_consulter')">
                                {{ $t('requestToPay.stream_in')}}
                              </th>
                              <th v-if="fileFormat && hasRight('xmlDetail_consulter')">
                                {{ $t('requestToPay.stream_out')}}
                              </th>
                              <th>
                                {{ $t('requestToPay.stream_out_status')}}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="record in payment.history" :key="record.id">
                              <td v-if="(record.status !== '20' && isHRTP) || isSRTP">
                                {{ $options.filters.formatDateTime(record.creationDate) }}
                              </td>
                              <td v-if="(record.status !== '20' && isHRTP) || isSRTP">
                                {{ getHistoryLabel(record.status) }}
                              </td>
                              <td v-if="(fileFormat && hasRight('xmlDetail_consulter')) && ((record.status !== '20' && isHRTP) || isSRTP || isPSD2)">
                                <div v-if="!canSeeFormatIn(record)">-</div>
                                <div v-else class="d-xl-flex align-items-center justify-content-center">
                                  {{record.format.in.type}}
                                  <div>
                                    <i class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.in, 'payment', 'see')"></i>
                                    <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.in, 'payment', 'download')"></i>
                                  </div>
                                </div>
                              </td>
                              <td v-if="(fileFormat && hasRight('xmlDetail_consulter')) && ((record.status !== '20' && isHRTP) || isSRTP || isPSD2)">
                                <div v-if="!canSeeFormatOut(record)">-</div>
                                <div v-else class="d-xl-flex align-items-center justify-content-center">
                                  {{record.format.out.type}}
                                  <div>
                                    <i class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'payment', 'see')"></i>
                                    <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'payment', 'download')"></i>
                                  </div>
                                </div>
                              </td>
                              <td v-if="((record.status !== '20' && isHRTP) || isSRTP || isPSD2)">
                                <div v-if="record.format.out.technicalCode === TECHNICAL_CODE.OK">
                                  <span>{{ record.format.out.technicalDescription }}</span>
                                  <i class="fa fa-check px-2 color-var-actionButtonColorBlue"></i>
                                  <i v-if="canSeeErrorBody(record)" class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'payment', 'see')"></i>
                                  <i v-if="canSeeErrorBody(record)" class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'payment', 'download')"></i>
                                </div>
                                <div v-else-if="record.format.out.technicalCode === TECHNICAL_CODE.KO">
                                  <span>{{ record.format.out.technicalDescription }}</span>
                                  <i class="fa fa-xmark px-2 color-red"></i>
                                  <i v-if="canSeeErrorBody(record)" class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'payment', 'see')"></i>
                                  <i v-if="canSeeErrorBody(record)" class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(record.format.out, 'payment', 'download')"></i>
                                </div>
                                <div v-else-if="record.format.out.technicalCode === TECHNICAL_CODE.NO_ANSWER">
                                  <span>{{ record.format.out.technicalDescription }}</span>
                                  <i class="fa-solid fa-plug-circle-xmark px-2 redIcon"></i>
                                </div>
                                <div v-else>-</div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </b-col>
                    </b-row>
                  </div>
                </form-accordion>
              </div>
            </div>
            <div v-else>
              <label class="font-bold w-100 d-flex justify-content-center mt-3">{{ $t('common.no_payment') }}</label>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <div class="ml-3 mr-3" slot="footerButtons" v-if="!activateSpinner">
        <div v-if="!details.id || (showOtherDebtors() && otherRTP.length === 0)"></div>
        <div v-else>
          <b-row v-if="details.direction === '0'" class="inboxDetailButton">
            <b-col md="10" offset-md="2">
              <b-row class="justify-content-end no-gutters">
                <!-- <b-col md="2" v-if="LMSGsupplierconfig"> -->
                  <!-- ACCEPT AND PAY AXEPTA -->
                  <!-- <b-button variant="primary" size="lg"
                    v-if="waitingForAnswerRTP(details.status) && details.pay !== 'none' && !$engine.user.isOtp"
                    @click="showPaymentAxepta()">
                    {{ $t('common.accpt_nd_pay') }}
                  </b-button> -->
                  <!-- PAY AXEPTA -->
                  <!-- <b-button variant="primary" size="lg"
                    v-if="(details.status === status.ACCEPTED || details.status === status.MODIFIED) && details.pay !== 'none' && !$engine.user.isOtp"
                    @click="showPaymentAxepta()">
                    {{ $t('common.pay') }}
                  </b-button> -->
                <!-- </b-col> -->

                <!-- INVALID ACCOUNT (HRTP) -->
                <b-button variant="primary" size="lg" v-if="showButtonInvalidAccount && isHRTP"
                  class="mx-2"
                  @click="payerNotFound">
                  {{ $t('common.invalid_account') }}
                </b-button>

                <!-- REFUSE -->
                <b-button variant="primary" size="lg" v-if="showButtonRefuse && isSRTP"
                  class="mx-2"
                  @click="transactionRefused">
                  {{ $t('common.refus') }}
                </b-button>

                <!-- REFUSE (HRTP)-->
                <b-button variant="primary" size="lg" v-if="showButtonRefuse && isHRTP"
                  class="mx-2"
                  @click="transactionRefused">
                  {{ $t('common.refus_hrtp') }}
                </b-button>

                <!-- PAY -->
                <b-button variant="primary" size="lg" v-if="showButtonPay"
                  class="mx-2"
                  @click="pay()">
                  {{ $t('common.pay') }}
                </b-button>

                <!-- PAYMENT REJECTED (HRTP) -->
                <b-button variant="primary" size="lg" v-if="showButtonPaymentValidate"
                  class="mx-2"
                  @click="payementRejected">
                  {{ $t('common.payment_reject') }}
                </b-button>

                <!-- PAYMENT VALIDATED (HRTP) -->
                <b-button variant="primary" size="lg" v-if="showButtonPaymentValidate"
                  class="mx-2"
                  @click="payementValidated">
                  {{ $t('common.payment_validate') }}
                </b-button>

                <!-- ACCEPT AND PAY -->
                <b-button variant="primary" size="lg"  v-if="showButtonAcceptAndPay && isSRTP"
                  class="mx-2"
                  @click="transactionAcceptedAndPay">
                  {{ $t('common.accpt_nd_pay') }}
                </b-button>

                <!-- ACCEPT (HRTP) -->
                <b-button variant="primary" size="lg"  v-if="showButtonAccept && isHRTP"
                  class="mx-2"
                  @click="buttonAccept">
                  {{ $t('common.accpt_hrtp') }}
                </b-button>

                <!-- ACCEPT -->
                <b-button variant="primary" size="lg" v-if="showButtonAccept && isSRTP"
                  class="mx-2"
                  @click="buttonAccept">
                  {{ $t('common.accpt') }}
                </b-button>

              </b-row>
            </b-col>
          </b-row>

          <!-- Détails pour une demande envoyée -->
          <!-- Vraie négociation inactive : Simple modification actuellement utilisée -->
          <div v-if="details.direction === '1' && (['1','5','9','10'].includes(details.status))">
            <b-row class="justify-content-end no-gutters">
              <!-- CANCEL HRTP-->
              <b-button v-if="isHRTP && showButtonCancel" variant="primary" size="lg"
                @click="cancelRequestToPay(details.endToEndId, 'SL02', 'Code')">
                {{ $t('requestToPay.cancel_rtp_hrtp') }}
              </b-button>
              <!-- CANCEL -->
              <b-button v-else-if="isSRTP && showButtonCancel" variant="primary" size="lg"
                @click="cancelRequestToPay(details.endToEndId)">
                {{ $t('requestToPay.cancel_rtp') }}
              </b-button>
            </b-row>

            <!-- <b-row class="justify-content-start" v-if="waitingForAnswerRTP(details.status)"> -->
              <!-- <div class="col-md-3 offset-md-1">
                <button rounds class="button-action firstButtonMarginTop milkyBlockBlack"
                  @click="cancelRequestToPay(details.endToEndId)">
                  {{ $t('requestToPay.cancel_rtp') }}
                </button>
              </div> -->
              <!-- <b-col md="3" offset-md="4" class="form-group">
                <b-button
                  v-if="false"
                  class="btn"
                  size="lg"
                  @click="remindReceiver(details.id)">
                  <f7-icon fa="bell"></f7-icon>
                  {{ $t('requestToPay.remind_rcvr') }}
                </b-button>
              </b-col> -->
            <!-- </b-row> -->
          </div>
        </div>
      </div>
    </template>
  </page-outline>
</template>

<script>
import b64toBlob from 'b64-to-blob'
import moment from 'moment'
import _ from 'lodash'

import backButton from '@/components/common/backButton.vue'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import documentList from '@/components/common/documentList.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import spinner from '@/components/common/spinner.vue'

import bankDatas from '@/pages/requests/components/data/bankDatas.json'
import Echeancier from '@/pages/requests/EcheancierForm.vue'
import selectBankAccount from '@/pages/requests/components/selectBankAccount.vue'
import TransactionsList from '@/pages/requests/TransactionsList.vue'

import { errorMessageAlert } from '@/helpers/alert'
import { downloadFileWithDefinedHeaders } from '@/helpers/download'
import { formatDateTime, formatIbanHiddenEnd, formatLettrage } from '@/helpers/format'
import { loadPage } from '@/helpers/routing'
import services from '@/helpers/services'
import Services from '@/helpers/services'
import { statusLabel, statusIcon, getCancelLabel, currencySymbol } from '@/helpers/labels'
import status from '@/helpers/status'

export default {
  name: 'transaction-details',
  components: {
    'datetime-picker-custom': dateTimePicker,
    echeancier: Echeancier,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    spinner: spinner,
    'transactions-list': TransactionsList,
    'back-button': backButton,
    'document-list': documentList,
    'select-bank-account': selectBankAccount
  },
  data () {
    return {
      acceptInstallments: true,
      action: '',
      activateSpinner: false,
      amountError: false,
      amountErrorMessage: '',
      amountFilter: '',
      arrayStatusListPayment: ['1', '2', '5', '6', '21', '22'],
      attachement: '',
      attachementId: '',
      attachementName: '',
      attachementReference: '',
      amountBeforeModify: '',
      bankAccountSelectDebit: '',
      colors: ['#ffffff','#00a76d18'],
      dateExecError: false,
      dateExecErrorMessage: '',
      debtorBankAccount: '',
      details: {},
      fields: [
        {
          key: 'datetime',
          label: this.$t('Date de génération du fichier'),
          class: 'text-center w-25', sortable: true
        },
        {
          key: 'type_format',
          label: this.$t('Type du fichier généré'),
          class: 'text-center w-25',
        },
        {
          key: 'see',
          label: this.$t('Voir le fichier'),
          class: 'text-center w-25',
        },
        {
          key: 'download',
          label: this.$t('common.dwnld'),
          class: 'text-center w-25',
        },
      ],
      fileFormat: [],
      filterTimer: '',
      hasInstallmentsChanged: false,
      hasOriginalAmountChanged: false,
      hasOriginalDateChanged: false,
      ImmPmtAccepted: '',
      idRequest: '',
      idRefresh: undefined,
      installmentRefresh: false,
      keyTableInstallments: false,
      label: '',
      LMSGsupplierconfig: this.$engine.services.suppliers.LMSGsupplierconfig,
      maxAmount: '',
      multPmts: [],
      nbRefresh: 0,
      noPaymentsFiltered: false,
      numInstallments: '1',
      originalAmount: '',
      originalDate: '',
      originalInstallements: '',
      originalReason: '',
      oldAmountGet: '',
      oldDateGet: '',
      oneTimePayment: undefined,
      otherRTP: [],
      payments: [],
      paymentInstalmentModeChoosed: false,
      paymentMethod: '',
      payStatus: '0',
      randomId: Math.random().toString(36).substr(2, 10),
      randomStringStatusFilter: '',
      receivedPayments: [],
      refreshTimers: [5, 10, 15, 30, 60], // temps en secondes de chaque refresh auto
      returnUrl: 'none',
      services: services,
      settings: this.$engine.settings.get(Services.PAYMENTS),
      showIbanBox: false,
      showInstallments: false,
      showReason: false,
      standard: '1',
      status: status,
      statusFilter: '',
      statusList: {
        statusPaymentInitiated: {
          id: '1',
          state: 0
        },
        statusPaymentRegistered: {
          id: '2',
          state: 0
        },
        statusPaymentAcknowledged: {
          id: '5',
          state: 0
        },
        statusPaymentRejected: {
          id: '6',
          state: 0
        },
        statusPaymentRejectedByBank: {
          id: '21',
          state: 0
        },
        statusPaymentSettled: {
          id: '22',
          state: 0
        }
      },
      tabName: 0,
      transactionIdFilter: '',
      TECHNICAL_CODE: {
        OK: '1',
        KO: '2',
        NO_ANSWER: '3'
      },
      today: moment().format()
    }
  },
  created () {
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    this.$bus.$off('refresh-cache-attachments')
    this.$bus.$off('refresh-cache-account-members')

    if (this.details.id) {
      this.oldAmountGet = this.details.amount
      this.oldDateGet = this.details.requestedExecutionDate
    }
    if (this.details.dbBkAcct !== '') {
      this.bankAccountSelectDebit = this.details.debtorBankAccount
    } else {
      if (
        this.$engine.bankAccounts.getDefaultBankAccount().iban !== undefined
      ) {
        this.bankAccountSelectDebit =
          this.$engine.bankAccounts.getDefaultBankAccount().iban
      } else {
        this.bankAccountSelectDebit = ''
      }
    }
    this.paymentMethod = this.$engine.settings.get(1).paymentMethod

    this.$bus.$off('pay-transaction')
    this.$bus.$on('pay-transaction', (data) => {
      this.debtorBankAccount = data.bankAccount
      if (this.payStatus === '1') {
        this.pay()
      } else {
        this.transactionAcceptedAndPay()
      }
    })

    let that = this
    this.$bus.$off('answer-to-payments')
    this.$bus.$on('answer-to-payments', (data) => {
      that.acceptInstallments = data.acceptInstallments
      that.oneTimePayment = data.oneTimePayment
      that.paymentInstalmentModeChoosed = true
      that.answerToPayments(data.status, data.optionals)
    })

    this.$bus.$off('cancel-payment')
    this.$bus.$on('cancel-payment', (data) => {
      that.cancelRequestToPay(data.endToEndId, data.reason, data.reasonType)
    })

    this.seeDetails()

    /* Récupération des autres paiements */
    if (this.showOtherDebtors()) {
      let filterConditions = {
        IdGroup: this.details.IdGroup,
      }
      this.$engine.services.payments
        .update(2, 100, 1, filterConditions)
        .then((resp) => {
          that.otherRTP = resp.data.payments
        })
        .catch((error) => {
          errorMessageAlert(error, that)
        })
    }
  },
  mounted () {
    this.randomStringStatusFilter = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)
  },
  beforeDestroy () {
    this.attachementName = ''
    this.attachment = ''
    this.attachementReference = ''
  },
  computed: {
    bankAccounts () {
      return this.$engine.bankAccounts.get()
    },
    canSeePaymentDetails () {
      return this.details.paymentRequest === "1" && this.$engine.rights.rightIs('rtp_payment_details_consulter', true)
    },
    canSeeRTPBack() {
      return this.$engine.rights.rightIs('rtp_backoffice_consulter', true)
    },
    canSeePain001 () {
      return this.$engine.rights.rightIs('xmlDetail_consulter', true) &&
        this.details.paymentRequest &&
        this.details.paymentRequest.format &&
        this.details.paymentRequest.format.out &&
        this.details.paymentRequest.format.out.id
    },
    getCancelReason () {
      // reason et reasonType
      if (this.details.cancelReasonType === 'Proprietary') {
        return this.details.cancelReason
      } else {
        let cancelReason = this.details.cancelReason.split(' ')[0]
        let reasonVar = ''
        if (this.details.cancelReason.split(' ').length > 1) {
          reasonVar = this.details.cancelReason.split(' ')
          reasonVar.shift()
          reasonVar = reasonVar.join(' ')
        }
        return this.$i18n.t('common.cancel_reason.' + cancelReason, {var: reasonVar})
      }
    },
    getRefusReason () {
      // cancelReason et cancelReasonType
      if (this.details.rejectReasonType === 'Proprietary') {
          return this.details.rejectReason
      } else {
        let rejectReason = this.details.rejectReason.split(' ')[0]
        let reasonVar = ''
        if (rejectReason === 'NARR' && this.details.additionalInformation) {
          return this.details.additionalInformation
        } else {
          if (this.details.rejectReason.split(' ').length > 1) {
            reasonVar = this.details.rejectReason.split(' ')
            reasonVar.shift()
            reasonVar = reasonVar.join(' ')
          } else if (this.details.rejectReason.split(' ').length <= 1 && !this.details.rejectReason.split(' ')[0]) {
            return ''
          }
        }
        return this.$i18n.t('common.reject_reason.' + rejectReason, {var: reasonVar})
      }
    },
    hasInputFilter () {
      if (
        this.transactionIdFilter ||
        this.amountFilter ||
        this.statusDisplay.nb > 0) {
        return true
      }
      return false
    },
    hasPastExecutionDate () {
      return ['9','10'].includes(this.details.status) && this.details.direction === '0'
        && (this.details.acceptedRequestedExecutionDatetime
          ? moment(this.details.acceptedRequestedExecutionDatetime) < moment()
          : moment(this.details.requestedExecutionDate) < moment())
    },
    installementExecutionDates: {
      get () {
        return moment(this.details.installments[0].Date).format('YYYY-MM-DDTHH:mm')
      },
      set (value) {
        this.details.installments[0].Date = value.format('YYYY-MM-DDTHH:mm:ss')
        this.details.installments[1].Date = this.details.installments[1].Date
      },
      get () {
        return moment(this.details.installments[1].Date).format('YYYY-MM-DDTHH:mm')
      },
      set (value) {
        this.details.installments[0].Date = this.details.installments[0].Date
        this.details.installments[1].Date = value.format('YYYY-MM-DDTHH:mm:ss')
      },

    },
    installmentsFields () {
      if (this.canSeePaymentDetails && this.receivedPayments && this.receivedPayments.length > 1) {
        return [
          { key: 'Number', label: this.$t('common.number_short'), class: 'text-center align-middle w-10', tdClass: 'font-weight-bold font-italic ' },
          { key: 'Date', label: this.$t('common.exec_date'), class: 'text-center align-middle w-25' },
          { key: 'Amount', label: this.$t('common.amnt_installment_rtp'), class: 'text-center align-middle w-25' },
          { key: 'TransactionId', label: this.$t('administration.transaction_identifier'), class: 'text-center align-middle w-20' },
          { key: 'Status', label: this.$t('common.status.payment_status_label'), class: 'text-center align-middle w-20' }
        ]
      } else {
        return [
          { key: 'Number', label: this.$t('common.number_short'), class: 'text-center align-middle w-20', tdClass: 'font-weight-bold font-italic ' },
          { key: 'Date', label: this.$t('common.exec_date'), class: 'text-center align-middle w-40', tdClass: 'z-10080' },
          { key: 'Amount', label: this.$t('common.amnt_installment_rtp'), class: 'text-center align-middle w-40' }
        ]
      }
    },
    isDebtorAnon () {
      return (
        this.details.debtorName === undefined || this.details.debtorName === ''
      )
    },
    isDebtorBankAccountAvailable () {
      return ['5', '9','10','11','12','120','121','20'].includes(this.details.status)
    },
    isDebtorBankAccountEditable () {
      return ['5','9','10'].includes(this.details.status)
    },
    isHRTP () {
      return this.standard === '2'
    },
    isPSD2 () {
      return this.standard === '3'
    },
    isSRTP () {
      return this.standard === '1'
    },
    isInstantPayment () {
      let today = moment().format('YYYY-MM-DD')
      if (this.details.executionDateResponse.length > 0) {
        return (
          moment(this.details.executionDateResponse).format('YYYY-MM-DD') ===
          today
        )
      } else {
        return (
          moment(this.details.requestedExecutionDate).format('YYYY-MM-DD') ===
          today
        )
      }
    },
    isUserDebtor () {
      return this.details.debtorIdProvider === this.$engine.settings.getGlobal().RTPSPIdentifier && this.details.debtorIdCompany === this.$engine.settings.get().clientIdentifier
    },
    oldAmount () {
      if (this.oldAmountGet === '' && this.details.amount) {
        this.oldAmountGet = this.details.amount
      }
      return this.oldAmountGet
    },
    oldDate () {
      if (this.oldDateGet === '' && this.details.requestedExecutionDate) {
        this.oldDateGet = this.details.requestedExecutionDate
      }
      return this.oldDateGet
    },
    realStatusList () {
      let that = this
      const list = []
      for (const property in that.statusList) {
        const status = that.statusList[property]
        list.push({
          tag: property,
          state: status.state,
          id: status.id
        })
      }
      return list
    },
    requestedExecutionDateFormat: {
      get () {
        return this.details.requestedExecutionDate
      },
      set (value) {
        this.details.requestedExecutionDate = value
      }
    },
    showButtonAccept () {
      return (
        this.details.direction === '0' &&
        (this.details.status === '5' || this.details.status === '1') &&
        this.$engine.rights.rightIs('paymentRequestResponse_ajouter', true)
      )
    },
    showButtonAcceptAndPay () {
      // for SRTP, need validate and pay right
      // for HRTP, only need validate right
      if(this.$engine.rights.rightIs('paymentRequestResponse_ajouter', true) &&
        ((this.$engine.rights.rightIs('paymentpay_ajouter', true) && this.isSRTP) || this.isHRTP)) {
        return (
          this.details.direction === '0' &&
          (this.details.status === '5' || this.details.status === '1') &&
          this.details.creditNoteAmount === undefined
        )
      }
    },
    showButtonCancel () {
      // admin have access only on the debtors part
      let cancelationFailed = false
      this.details.history.forEach(record => {
        if(record.status === '15') {
          cancelationFailed = true
        }
      })
      if (this.$engine.rights.rightIs('paymentCancel_ajouter', true) && !cancelationFailed) {
        return true
      }
    },
    showButtonInvalidAccount () {
      // for SRTP, need validate and pay right
      // for HRTP, only need validate right
      if(this.$engine.rights.rightIs('paymentRequestResponse_ajouter', true) &&
        ((this.$engine.rights.rightIs('paymentpay_ajouter', true) && this.isSRTP) || this.isHRTP)) {
        return (
          this.details.direction === '0' &&
          (this.details.status === '5' || this.details.status === '1') &&
          this.details.creditNoteAmount === undefined &&
          !this.details.history.map(elem => elem.status).includes('4')
        )
      }
    },
    showButtonPay () {
      let hasRightStatus = true

      return (this.$engine.rights.rightIs('paymentpay_ajouter', true) &&
        this.details.direction === '0' &&
        ['9','10'].includes(this.details.status) &&
        this.details.pay !== 'none' &&
        this.details.creditNoteAmount === undefined &&
        !this.$engine.user.isOtp &&
        this.isSRTP
      )
    },
    showButtonPaymentValidate () {
      // This button is only for HRTP
      let statusWasThere = false //DRO 25/08/202 variable vraie si nous avons eu le statut correspondant dans l'historique, fausse si le contraire (utilisée lorsqu'une HRTP à une annulation rejetée)
      this.details.history.forEach( record => {
        if (['9', '10'].includes(record.status)) {
          statusWasThere = true
        }
        if (['21', '22', '25'].includes(record.status)) {
          statusWasThere = false
        }
      })
      if(this.$engine.rights.rightIs('paymentRequestResponse_ajouter', true)) {
        return ((this.details.direction === '0' &&
          ['9', '10'].includes(this.details.status) &&
          statusWasThere === true &&
          this.details.pay !== 'none' &&
          this.details.creditNoteAmount === undefined &&
          this.isHRTP)
        )
      }
    },
    showButtonRefuse () {
      return (
        this.$engine.rights.rightIs('paymentRequestResponse_ajouter', true) &&
        this.details.direction === '0' &&
        (this.details.status === '5' || this.details.status === '1')
      )
    },
    statusDisplay () {
      let realStatusList = this.realStatusList.filter(status => status.state === 1)
      if (realStatusList.length === 0) {
        return {
          label: this.$t('filter.selected_status_none'),
          nb: 0
        }
      } else if (realStatusList.length === 1) {
        return {
          label: this.$t('common.status.payment.' + realStatusList[0].id),
          nb: 1
        }
      } else {
        return {
          label: this.$t('filter.selected_status_many', {nbStatus: realStatusList.length}),
          nb: realStatusList.length
        }
      }
    },
    titleIcon () {
      if (this.details.direction === '0') {
        return 'icon-inbox'
      } else {
        return 'icon-sent'
      }
    },
    titleLabel () {
      return this.$t('requestToPay.rtp_details')
    },
    userIdentifier () {
      return this.$engine.user.get().identifier
    }
  },
  methods: {
    getBgColor(index) {
      return 'payment-color-' + (index % this.colors.length)
    },
    getPayments () {
      this.activateSpinner = true
      this.$engine.services.payments.updatePayment(
        this.idRequest
      ).then(resp => {
        if (resp.data && resp.data.payments && resp.data.payments.length) {
          this.receivedPayments = resp.data.payments
          this.payments = resp.data.payments
        }
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
      })
    },
    answerToPayments (status, optionals = { ImmPmtAc: 'false', reasonType: '', reason: '', additionnalInformation: ''}) {
      if (status !== '11' && this.details.installments && this.details.installments.length && !this.paymentInstalmentModeChoosed) {
        //formattage nécessaire des installments si ils sont modifiés (DRO 04/04/2024)
        let formattedInstallements = {}
        if (this.showAcceptModifyDate()) {
          let tempInstallements = _.cloneDeep(this.details.installments)
          tempInstallements.forEach((installment, index) => {
            installment.Date = formatDateTime(installment.Date)
          })
          formattedInstallements = tempInstallements
        }

        this.$bus.$emit('popup-choice-payment-instalment', {
          'amount': this.details.amount,
          'currency': this.details.currency,
          'hasOriginalAmountChanged': this.hasOriginalAmountChanged,
          'hasOriginalDateChanged': this.hasOriginalDateChanged,
          'installments': Object.keys(formattedInstallements).length > 0 ? formattedInstallements : this.details.installments,
          'optionals': optionals,
          'requestedExecutionDate': formatDateTime(this.details.requestedExecutionDate).length <= 0 ? this.details.requestedExecutionDate : formatDateTime(this.details.requestedExecutionDate),
          'status': status
        })
        return
      } else if (status === '11' && this.details.installments && this.details.installments.length) {
        this.oneTimePayment = '1'
      }

      let today = moment().format('YYYY-MM-DD')
      if (this.details.acceptModifyExecutionDate === '1' && moment(formatDateTime(this.details.requestedExecutionDate)).format('YYYY-MM-DD') < today) {
        this.$f7.alert('', this.$t('errors.invld_exec_dt'))
        return
      }
      let execDate = optionals.ImmPmtAc === 'true' ? today : moment(formatDateTime(this.details.requestedExecutionDate)).format('YYYY-MM-DD')
      let that = this
      let debtorBankAccountToSend = ''
      debtorBankAccountToSend = that.bankAccountSelectDebit
      let amount =  this.details.amount
      amount =
        parseFloat(amount) % 1 === 0 ? amount : parseFloat(amount).toFixed(2)
      let multiplePaymentsToSend = []
      let data = {
        idRequest: that.details.id,
        debtorName: this.details.debtorName,
        debtorIdentifier: this.details.debtorIdCompany,
        textStatus: status,
        amount: this.details.amountResponse ? this.details.amountResponse : this.details.amount,
        currency: this.details.currency,
        oneTimePayment: this.oneTimePayment
      }

      if (status === '6' && this.isHRTP) {
        data.reasonType = optionals.reasonType
        data.reason = optionals.reason
      }

      if (status === '9') {
        if (this.originalDate !== formatDateTime(this.details.requestedExecutionDate)) {
          data.executionDate = this.originalDate,
          data.acceptedExecutionDateTime = formatDateTime(this.details.requestedExecutionDate)
        }

        if (this.originalReason !== this.details.reason || this.isHRTP) {
          data.acceptedReason = this.details.reason
        }
      }

      if (status === '10' && this.isHRTP) {
        data.acceptedReason = this.details.reason
      }

      //change reason to code if RJCT
      if (status === '11') {
        if (optionals.reasonType === 'OTHER') {
          data.reasonType = 'Proprietary'
          data.reason = optionals.reason
        } else if (this.isHRTP) {
          data.reasonType = 'Code'
          data.reason = 'DS02'
          if(optionals.reason === undefined || optionals.reason === '' ) {
            data.additionalInformation = undefined
          } else {
            data.additionalInformation = optionals.reason
          }
        } else {
          data.reasonType = 'Code'
          data.reason = optionals.reasonType
        }
      }

      if ((status === '21' || status === '25') && this.isHRTP) {
        data.reasonType = optionals.reasonType
        data.reason = optionals.reason
        data.additionalInformation = optionals.additionalInformation
        data.acceptedExecutionDateTime = this.details.requestedExecutionDate
        if (!this.details.acceptedRemittanceInformation) {
          data.acceptedReason = ''
        } else {
          data.acceptedReason = this.details.acceptedRemittanceInformation
        }
      }
      if(status === '22' && this.isHRTP) {
        if (!this.details.acceptedRemittanceInformation) {
          data.acceptedReason = ''
        } else {
          data.acceptedReason = this.details.acceptedRemittanceInformation
          data.reasonType = undefined
          data.reason = undefined
        }
      }

      // add installments if necessary
      if (this.details.installments && this.details.installments.length && (this.oneTimePayment !== '1' || status === '11')) {
        let installments = status === '11' ? this.originalInstallements : this.details.installments
        data.installments = []
        installments.forEach((inst) => {
          data.installments.push({
            RequestedExecutionDate: formatDateTime(inst.Date),
            Amount: inst.Amount,
            Currency: data.currency,
          })
        })
      }

      that.$engine.services.payments
        .answerToPayments(data)
        .then((response) => {
          if (response.status === 200) {
            that.changeReturnUrl()
            if (that.payStatus === '1') {
              if (status === '21' || status === '25') {
                if (that.isHRTP) {
                  that.$f7.modal({
                    title: that.$t('common.status.rtp.' + status),
                    text: '<span class="preloader"></span>'
                  })
                } else {
                  that.$f7.modal({
                    title: that.$t('common.status.rejected_request'),
                    text: '<span class="preloader"></span>'
                  })
                }
              } else {
                if (that.isHRTP && status === '10') {
                  that.$f7.modal({
                    title: that.$t('common.status.accepted_request_hrtp'),
                    text: '<span class="preloader"></span>'
                  })
                } else if (that.isHRTP && status === '22') {
                  that.$f7.modal({
                    title: that.$t('common.status.rtp.22'),
                    text: '<span class="preloader"></span>'
                  })
                } else {
                  that.$f7.modal({
                    title: that.$t('common.status.accepted_request'),
                    text: '<span class="preloader"></span>'
                  })
                }
              }
              setTimeout(function () {
                that.$f7.closeModal()
                that.payStatus = '1'
                // appeler paiement
                if(that.isSRTP) {
                  that.pay()
                } else {
                  if (['21', '22', '25'].includes(status)) {
                    that.seeDetails()
                  } else {
                    that.pay()
                  }
                }
              }, 2000)
            } else {
              let titleText = ''
              switch (status) {
                case '6':
                  that.$f7.modal({
                    title: that.$t('common.status.invalid_act'),
                    text: '<span class="preloader"></span>',
                  })
                  break
                case '10':
                case '9':
                  that.$f7.modal({
                    title: that.$t('common.status.accepted_request'),
                    text: '<span class="preloader"></span>',
                  })
                  break
                case 'modify':
                  that.$f7.modal({
                    title: that.$t('requestToPay.pymnts_effctv_on') + execDate,
                    text: '<span class="preloader"></span>',
                  })
                  break
                case '11':
                  if (that.isSRTP) {
                    that.$f7.modal({
                      title: that.$t('common.trnsctn_rfsd'),
                      text: '<span class="preloader"></span>',
                    })
                  } else if (that.isHRTP) {
                    that.$f7.modal({
                      title: that.$t('common.trnsctn_rfsd_hrtp'),
                      text: '<span class="preloader"></span>',
                    })
                  }
                  break
                case '21':
                  if (that.isHRTP) {
                    titleText = that.$t('common.status.rtp.21')
                  } else {
                    titleText = that.$t('common.status.rejected_request')
                  }
                  that.$f7.modal({
                    title: titleText,
                    text: '<span class="preloader"></span>',
                  })
                  break
                case '22':
                  if (that.isHRTP) {
                    titleText = that.$t('common.status.rtp.22')
                  } else {
                    titleText = that.$t('common.status.accepted_request')
                  }
                  that.$f7.modal({
                    title: titleText,
                    text: '<span class="preloader"></span>',
                  })
                  break
                case '25':
                  if (that.isHRTP) {
                    titleText = that.$t('common.status.rtp.25')
                  } else {
                    titleText = that.$t('common.status.refused_payment')
                  }
                  that.$f7.modal({
                    title: titleText,
                    text: '<span class="preloader"></span>',
                  })
                  break
                default:
                  that.$f7.modal({
                    title: this.$t('common.unknwn_actn'),
                    text: '<span class="preloader"></span>',
                  })
              }
              setTimeout(function () {
                that.$f7.closeModal()
                that.$engine.settings.set({ pendingChange: true })
                that.$engine.settings.set({ inboxNormalCount: null })
                that.seeDetails()
              }, 2000)
            }
          }
        })
        .catch((error) => {
          this.payStatus = '0'
          this.debtorBankAccount = ''
          let errMsgTitle = ''
          let errMsgDesc = ''
          if (error && error.response && error.response.data && error.response.data.error) {
            if (('errors._specific.title.' + error.response.data.error) !== that.$t('errors._specific.title.' + error.response.data.error)) {
              errMsgTitle = that.$t('errors._specific.title.' + error.response.data.error)
              errMsgDesc = that.$t('errors._specific.description.' + error.response.data.error)
            }
          }
          if (errMsgTitle && errMsgDesc) {
            that.$f7.alert(errMsgDesc, errMsgTitle)
          } else {
            errorMessageAlert(error, that)
          }
        })
    },
    applyFilter() {
      let that = this
      this.noPaymentsFiltered = false
      this.activateSpinner = true
      clearTimeout(this.filterTimer)
      let statusArray = []
      for (let property in this.statusList) {
        let status = that.statusList[property]
        if(status.state === 1) {
          statusArray.push(status.id)
        }
      }
      if (this.transactionIdFilter === '' && this.amountFilter === '' && statusArray.length === 0) {
        this.payments = this.receivedPayments
        this.activateSpinner = false
      } else {
        let filteredPayments = this.receivedPayments.map((payment) =>  {
          let passed = true;
          if (this.transactionIdFilter.length > 0) {
            passed = payment.TransactionId.includes(this.transactionIdFilter)
          } if (this.amountFilter.length > 0) {
            passed = payment.amount.includes(this.amountFilter)
          } if (statusArray.length > 0) {
            passed = statusArray.includes(payment.status)
          }
          if (passed === false) {
            return {}
          } else {
            return payment
          }
        })
        /* Si tous les paiements sont en mode {} (ex : [{}, {}...]), alors pas de paiements filtrés */
        let paymentFound = false
        filteredPayments.forEach((payment) => {
          if (Object.keys(payment).length > 0) {
            paymentFound = true
          }
        })
        if (paymentFound === false) {
          this.noPaymentsFiltered = true
        } else {
          this.payments = filteredPayments
        }
        this.activateSpinner = false
      }
    },
    buttonAccept () {
      let that = this

      if (this.isHRTP) {
        this.$f7.modal({
          title: that.$i18n.t('common.accpt_hrtp'),
          text: that.$i18n.t('common.action_question'),
          buttons: [{
            text: that.$t('administration.no'),
            onClick: that.$f7.closeModal()
          }, {
            text: that.$t('administration.yes'),
            onClick: function () {
              that.debtorBankAccount = ''
              that.payStatus = '0'
              that.transactionAccepted()
            }
          }]
        })
      } else {
        this.debtorBankAccount = ''
        this.payStatus = '0'
        this.transactionAccepted()
      }
    },
    cancelRequestToPay (endToEndId, reason = '', reasonType = '') {
      if (reasonType === '' || (reasonType === '' && this.isHRTP)) {
        this.$bus.$emit('popup-choice-payment-cancel', {
          endToEndId: endToEndId
        })
      } else {
        if (this.isHRTP) {
          const that = this
          this.$f7.modal({
            title: that.$i18n.t('requestToPay.cancel_rtp_hrtp'),
            text: that.$i18n.t('common.action_question'),
            buttons: [{
              text: that.$t('administration.no'),
              onClick: that.$f7.closeModal()
            }, {
              text: that.$t('administration.yes'),
              onClick: function () {
                that.$engine.services.payments
                .paymentsCancel(
                  that.idRequest,
                  reason,
                  reasonType
                )
                .then((response) => {
                  if (response.status === 200) {
                    that.changeReturnUrl()
                    that.$f7.modal({
                      title: that.$t('requestToPay.cancel_rtp'),
                      text: '<span class="preloader"></span>',
                    })
                    setTimeout(function () {
                      that.$f7.closeModal()
                      that.seeDetails()
                    }, 2000)
                  }
                })
                .catch((error) => {
                  let errMsg = that.$i18n.t('errors.AlreadyExpiredRTP')
                  if (error && error.response && error.response.data && error.response.data.error) {
                    if (('errors._specific.title.' + error.response.data.error) !== that.$t('errors._specific.title.' + error.response.data.error)) {
                      errMsg = that.$t('errors._specific.title.' + error.response.data.error)
                    }
                  }
                  that.$f7.alert(that.$i18n.t('errors.cncl_failed'), errMsg)
                })
              }
            }]
          })
        } else {
          const that = this

          that.$engine.services.payments
          .paymentsCancel(
            that.idRequest,
            reason,
            reasonType
          )
          .then((response) => {
            if (response.status === 200) {
              that.changeReturnUrl()
              that.$f7.modal({
                title: that.$t('requestToPay.cancel_rtp'),
                text: '<span class="preloader"></span>',
              })
              setTimeout(function () {
                that.$f7.closeModal()
                that.seeDetails()
              }, 2000)
            }
          })
          .catch((error) => {
            let errMsg = that.$i18n.t('errors.AlreadyExpiredRTP')
            if (error && error.response && error.response.data && error.response.data.error) {
              if (('errors._specific.title.' + error.response.data.error) !== that.$t('errors._specific.title.' + error.response.data.error)) {
                errMsg = that.$t('errors._specific.title.' + error.response.data.error)
              }
            }
            that.$f7.alert(that.$i18n.t('errors.cncl_failed'), errMsg)
          })
        }
      }
    },
    canSeeFormatIn (record) {
      return record.format.in.id && record.format.in.id !== '0' && record.format.in.type
    },
    canSeeFormatOut (record) {
      return record.format.out.id && record.format.out.id !== '0' && record.format.out.type
    },
    canSeeErrorBody (record) {
      return record.format.out.id && record.format.in.id !== '0' && record.format.out.technicalBody === '1'
    },
    changeInstallementAmounts(val, index) {
      let tempAmount = _.cloneDeep(val)
      let tempInstallements = _.cloneDeep(this.details.installments)
      tempInstallements[index].Amount = tempAmount
      this.details.installments = tempInstallements
    },
    changeInstallementDates(val, index) {
      let tempDate = _.cloneDeep(val)
      let tempInstallements = _.cloneDeep(this.details.installments)
      tempInstallements[index].Date = tempDate
      this.details.installments = tempInstallements
    },
    changeDebtorsAmount (changingNb = false){
      if (this.details.installments.length){
        if (this.details.amount === '' || parseFloat(this.details.amount) <= 0){
          for(let index = 0; index < this.details.installments.length; index++){
            this.details.installments[index].Amount = ''
          }
        } else {
          let installmentAmount = 0
          let installmentAmountTotal = 0
          let diff = -1
          let nbDiff = 0

          this.details.amount = parseFloat(this.details.amount).toFixed(this.standard === '2' ? 0 : 2).toString()
          while (diff < 0) {
            installmentAmountTotal = 0
            for (let index = 0 ; index < this.details.installments.length; index++) {
              let newAmount = ''
              installmentAmount = this.details.installments[index].Amount
              if (index === this.details.installments.length - 1 || parseFloat(this.details.amount) - installmentAmountTotal <= installmentAmount) {
                diff = parseFloat(this.details.amount) - installmentAmountTotal
                newAmount = diff.toFixed(this.standard === '2' ? 0 : 2).toString()
              } else if (this.details.installments[index].Amount === '' && parseFloat(this.details.amount) - installmentAmountTotal > 0 && changingNb) {
                newAmount = installmentAmount.toFixed(this.standard === '2' ? 0 : 2).toString()
              } else {
                if (changingNb) {
                  newAmount = installmentAmount.toFixed(this.standard === '2' ? 0 : 2).toString()
                } else if (this.details.installments[index].Amount === '') {
                  newAmount = '0.00'
                } else {
                  newAmount = parseFloat(this.details.installments[index].Amount).toFixed(this.standard === '2' ? 0 : 2).toString()
                }
              }

              if (newAmount === '0.00') {
                if (this.details.installments[index].Amount !== '' && this.details.installments[index].Amount !== '0.00') {
                  this.details.installments[index].Amount = ''
                }
              } else {
                if (this.details.installments[index].Amount !== newAmount){
                  this.details.installments[index].Amount = newAmount
                }
              }

              if (this.details.installments[index].Amount !== '') {
                if (parseFloat(this.details.installments[index].Amount) > 0) {
                  installmentAmountTotal += parseFloat(this.details.installments[index].Amount)
                }
              }
              nbDiff++
            }
          }
        }
      }
      if (this.details.amount) {
        this.details.amount = parseFloat(this.details.amount).toFixed(2)
      }
    },
    changeDebtorsDate () {
      this.details.installments.forEach((installment, indexInstallment) => {
        if (this.details.requestedExecutionDate < formatDateTime(installment.Date) && formatDateTime(installment.Date) !== ('Invalid date' || '')) {
          this.details.requestedExecutionDate = formatDateTime(installment.Date)
        }
      })
      this.details.installments.sort(this.orderInstallmentByDateString)
      this.installmentRefresh = !this.installmentRefresh
    },
    changeReturnUrl () {
      if (this.$engine.services.payments.office === 'front') {
        this.returnUrl = '/rtp/list/2/1'
      } else {
        this.returnUrl = '/rtp/listBack/2/1/1'
      }
    },
    checkForWritePermissions (sucess, error) {
      /* eslint-disable no-undef */
      if (this.$f7.device.os === 'android') {
        cordova.plugins.diagnostic.requestRuntimePermission(
          function (status) {
            switch (status) {
              case cordova.plugins.diagnostic.permissionStatus.GRANTED:
                sucess()
                break
              case cordova.plugins.diagnostic.permissionStatus.DENIED:
                error()
                break
              case cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
                error()
                break
            }
          },
          function (error) {
            console.error('The following error occurred: ' + error)
          },
          cordova.plugins.diagnostic.permission.WRITE_EXTERNAL_STORAGE
        )
      } else if (this.$f7.device.os === 'ios') {
        sucess()
      }
      /* eslint-enable no-undef */
    },
    clearFilterFields () {
      let that = this
      this.transactionIdFilter = ''
      this.amountFilter = ''
      for (let property in that.statusList) {
        that.statusList[property].state = 0
      }
      clearTimeout(this.filterTimer)
      this.applyFilter()
    },
    concatenatedDateAmountText (text) {
      return text + ' : ' + this.details.amount
    },
    concatenatedDateReasonText (text) {
      return text + ' : ' + this.details.reason
    },
    copyToClipboard (value) {
      const copyText = document.getElementById('inputUri')
      navigator.clipboard.writeText(copyText.innerHTML)
      const tooltip = document.getElementById('copyUri')
      const tooltipOrgnlText = tooltip.innerHTML
      tooltip.innerHTML = 'Copié !'
    },
    copyToClipboardReset (value) {
      const tooltip = document.getElementById('copyUri')
      tooltip.innerHTML = this.$t('common.copy_to_clipboard')
    },
    detailsAutoRefresh () {
      let refreshTimer = undefined
      if (this.nbRefresh >= this.refreshTimers.length) {
        refreshTimer = this.refreshTimers[this.refreshTimers.length - 1]
      } else {
        refreshTimer = this.refreshTimers[this.nbRefresh]
      }
      if (this.idRefresh) {
        clearTimeout(this.idRefresh)
        this.idRefresh = undefined
      }
      let that = this
      this.idRefresh = setTimeout(() => {
        that.seeDetails(true)
        that.nbRefresh++
      }, refreshTimer * 1000)
    },
    delayApplyFilter() {
      clearTimeout(this.filterTimer)
      this.filterTimer = setTimeout(() => {
        this.applyFilter()
      }, 1500)
    },
    download (id) {
      /* eslint-disable no-undef */
      const that = this
      this.$f7.showPreloader('Downloading File')
      this.$engine.services.payments
        .getAttachmentDetail(id)
        .then((response) => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({
            Attachment: {
              data: response.data.documentData,
              name: response.data.documentName,
              mimeType: response.data.documentData
                .split('')[0]
                .replace(/^data:/, ''),
              id: id,
            },
          })
          that.writeToFile(
            response.data.documentName,
            response.data.documentData,
            response.data.documentData.split(';')[0].replace(/^data:/, ''),
            false,
            function (filePath, fileType) {
              that.$f7.alert(
                filePath.split('/')[filePath.split('/').length - 1],
                'Following file successfully saved.'
              )
            },
            function () {
              that.$f7.alert('', 'Error creating the file')
            }
          )
        })
        .catch((error) => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
      /* eslint-enable no-undef */
    },
    formateInstalmentDate (dt) {
      return dt
    },
    formatLettrage: formatLettrage,
    getBankName (iban) {
      const code = iban.substring(4, 9)
      const bankName = bankDatas.Banks.find((e) => e.code === code).name
      return bankName
    },
    getCancelCodeLabel (code) {
      return getCancelLabel(code)
    },
    getExpirationDate (item) {
      let creationDate = item.creationDate
      let globalSettings = this.$engine.settings.getGlobal(1)['HRTP-ValidityPeriod']
      return moment(creationDate).add(globalSettings, 'M')
    },
    getHistoryIcon (status) {
      return statusIcon(status)
    },
    getHistoryLabel (status) {
      let status_label
      if (this.canSeePaymentDetails && this.tabName === 1) {
        status_label = this.$i18n.t('common.status.payment.' + status)
        if (status_label === ('common.status.payment.' + status)) {
          status_label = this.$i18n.t('common.status.unknown')
        }
      } else {
        if (status === '1' && this.details.direction === '0') {
          status_label = this.$i18n.t('common.status.received_request')
        } else if (status === '1' && this.details.direction === '1') {
          status_label = this.$i18n.t('common.status.issued_request')
        } else {
          status_label = this.$i18n.t('common.status.rtp.' + status)
          if (status_label === ('common.status.rtp.' + status)) {
            status_label = this.$i18n.t('common.status.unknown')
          }
        }
      }
      return status_label
    },
    getStatusLabel (status) {
      let status_label
      if (this.canSeePaymentDetails && this.tabName === 1) {
        status_label = this.$i18n.t('common.status.payment.' + status)
        if (status_label === ('common.status.payment.' + status)) {
          status_label = this.$i18n.t('common.status.unknown')
        }
      } else {
        if (status === '1' && this.details.direction === '0') {
          status_label = this.$i18n.t('common.status.received_request')
        } else if (status === '1' && this.details.direction === '1') {
          status_label = this.$i18n.t('common.status.issued_request')
        } else if (status === '20' && this.isHRTP) {
          if (this.details.acceptModifyAmount === '1' || this.details.acceptModifyRemittanceInformation === '1') {
            status_label = this.$i18n.t('common.status.rtp.9')
          } else {
            status_label = this.$i18n.t('common.status.rtp.10')
          }
        } else {
          status_label = this.$i18n.t('common.status.rtp.' + status)
          if (status_label === ('common.status.rtp.' + status)) {
            status_label = this.$i18n.t('common.status.unknown')
          }
        }
      }
      return status_label
    },
    getStatusReason (status) {
      let reason = undefined
      switch (status) {
        case '6':
        case '21':
        case '25':
          reason = this.getRefusReason
          return reason ? reason : this.$i18n.t('common.cancel_reason.OTHR')
        case '11':
          reason = this.isHRTP ? this.details.additionalInformation : this.getRefusReason
          return reason ? reason : this.$i18n.t('common.cancel_reason.OTHR')
        case '13':
        case '14':
          reason = this.getCancelReason
          return reason && !this.isHRTP ? reason : this.$i18n.t('common.cancel_reason.OTHR')
        default:
          return reason
      }
    },
    hasPastExecutionDateInstalment (installment) {
      return ['9','10'].includes(this.details.status) && this.details.direction === '0' && moment(installment.Date).isBefore(moment())
    },
    hasRight (right) {
      return this.$engine.rights.rightIs(right, true)
    },
    hideIban (iban) {
      return formatIbanHiddenEnd(iban)
    },
    isDataJSON (data) {
      let raw = data.substr(23)
      raw = atob(raw)
      try {
        return JSON.parse(raw)
      } catch (e) {
        return false
      }
    },
    openDoc (id) {
      // Get cloudDocument
      let that = this
      let win = window
      this.$f7.showPreloader(this.$i18n.t('loading.loading_file'))
      this.$engine.services.payments
        .getAttachmentDetail(id)
        .then((response) => {
          this.$engine.settings.set({
            Attachment: {
              data: response.data.documentData,
              name: response.data.documentName,
              mimeType: response.data.documentData
                .split('')[0]
                .replace(/^data:/, ''),
              id: id,
            },
          })
          if (
            that.$f7.device.os === 'android' ||
            that.$f7.device.os === 'ios'
          ) {
            that.$f7.hidePreloader()
            that.writeToFile(
              response.data.documentName,
              response.data.documentData,
              response.data.documentData.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else {
            // browser
            let blob = b64toBlob(
              response.data.documentData.split(',')[1],
              response.data.documentData.split('')[0].replace(/^data:/, '')
            )
            let url = window.URL.createObjectURL(blob)
            that.$f7.hidePreloader()
            win.open(url)
          }
        })
        .catch((error) => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
    },
    orderInstallmentByDateString(a, b) {
      // Comparer les propriétés data des objets
      if (formatDateTime(a.Date) < formatDateTime(b.Date)) {
        return -1
      } else if (formatDateTime(a.Date) > formatDateTime(b.Date)) {
        return 1
      } else {
        return 0
      }
    },
    pay () {
      if (!this.debtorBankAccount && !this.details.debtorBankAccount && this.payStatus === '0') {
        this.$bus.$emit('popup-choice-bank-account', {})
        return
      }
      const that = this
      this.$engine.services.payments.payRTP(this.idRequest, this.details.debtorBankAccount ? this.details.debtorBankAccount : this.debtorBankAccount)
        .then((response) => {
          if (response.status === 200) {
            that.changeReturnUrl()
            that.$f7.modal({
              title: that.$t('requestToPay.initiate_pay'),
              text: '<span class="preloader"></span>',
            })
            setTimeout(function () {
              that.$f7.closeModal()
              that.seeDetails()
            }, 2000)
          }
        })
        .catch((error) => {
          this.payStatus = '0'
          this.debtorBankAccount = ''
          let errMsgTitle = ''
          let errMsgDesc = ''
          if (error && error.response && error.response.data && error.response.data.error) {
            if (('errors._specific.title.' + error.response.data.error) !== that.$t('errors._specific.title.' + error.response.data.error)) {
              errMsgTitle = that.$t('errors._specific.title.' + error.response.data.error)
              errMsgDesc = that.$t('errors._specific.description.' + error.response.data.error)
            }
          }
          if (errMsgTitle && errMsgDesc) {
            that.$f7.alert(errMsgDesc, errMsgTitle)
          } else {
            errorMessageAlert(error, that)
          }
        })
    },
    payementRejected () {
      let that = this

      this.$bus.emit('popup-choice-reject-payment', {})
      return
    },
    payementValidated () {
      let that = this

      this.$f7.modal({
        title: this.$i18n.t('common.payment_validate'),
        text: this.$i18n.t('common.action_question'),
        buttons: [{
          text: this.$t('administration.no'),
          onClick: this.$f7.closeModal()
        }, {
          text: this.$t('administration.yes'),
          onClick: function () {
            that.answerToPayments('22')
          }
        }]
      })
    },
    payerNotFound () {
      let that = this

      this.$f7.modal({
        title: this.$i18n.t('common.invalid_account'),
        text: this.$i18n.t('common.action_question'),
        buttons: [{
          text: this.$t('administration.no'),
          onClick: this.$f7.closeModal()
        }, {
          text: this.$t('administration.yes'),
          onClick: function () {
            that.answerToPayments('6', {reasonType: 'Code', reason: 'AC02'})
          }
        }]
      })
    },
    readFile (filePath, fileType, fileName) {
      /* eslint-disable no-undef */
      // TODO : test fileType before trying to open and let the user know
      window.resolveLocalFileSystemURL(filePath, function (entry) {
        cordova.plugins.fileOpener2.open(
          entry.nativeURL.replace(/%20/g, ' '),
          fileType,
          {
            error: function (e) {
              // TODO : screen user stuff
            },
            success: function (s) {
              // TODO : screen user stuff
            },
          }
        )
      })
    },
    remindReceiver (id) {
      let that = this
      that.$engine.services.payments
        .paymentsRemind(id)
        .then((response) => {
          if (response.status === 200) {
            that.$f7.modal({
              title: 'Receiver reminded',
              text: '<span class="preloader"></span>',
            })
            setTimeout(function () {
              that.$f7.closeModal()
              that.seeDetails()
            }, 2000)
          }
        })
        .catch((error) => {
          errorMessageAlert(error, that)
        })
    },
    saveFileToDirectory (fileName, data, fileType, directory, success, error) {
      /* eslint-disable no-undef */
      let directoryEntryReference = null
      window.resolveLocalFileSystemURL(
        directory,
        function (directoryEntry) {
          directoryEntryReference = directoryEntry
          directoryEntry.getFile(
            fileName,
            { create: true, exclusive: true },
            function (fileEntry) {
              fileEntry.createWriter(
                function (fileWriter) {
                  fileWriter.onwriteend = function (e) {
                    success(e.target.localURL, fileType, fileName)
                  }
                  fileWriter.onerror = function (e) {
                    error()
                  }
                  let blob = b64toBlob(
                    data.replace(/^[^,]*,/, ''),
                    fileType
                  )
                  fileWriter.write(blob)
                },
                (e, file) => {}
              )
            },
            (e, file) => {
              navigator.notification.confirm(
                'This file already exists do you want to override it ? (' +
                  fileName +
                  ')',
                function (index) {
                  switch (index) {
                    case 1: // No
                      break
                    case 2: // Yes -> overrides  the file
                      directoryEntryReference.getFile(
                        fileName,
                        { create: true, exclusive: false },
                        function (fileEntry) {
                          fileEntry.createWriter(
                            function (fileWriter) {
                              fileWriter.onwriteend = function (e) {
                                success(e.target.localURL, fileType, fileName)
                              }
                              fileWriter.onerror = function (e) {
                                error()
                              }
                              let blob = b64toBlob(
                                data.replace(/^[^,]*,/, ''),
                                fileType
                              )
                              fileWriter.write(blob)
                            },
                            (e, file) => {}
                          )
                        },
                        (e, file) => {}
                      )
                      break
                  }
                },
                'Information',
                ['No', 'Yes']
              )
            }
          )
        },
        (e, file) => {
          // error resolveLocalFileSystemURL
        }
      )
      /* eslint-enable no-undef */
    },
    seeDetails (autoRefresh = false) {
      let that = this
      if (!autoRefresh) {
        this.activateSpinner = true
      }
      let method = 'updateBack'
      this.idRequest = this.$engine.services.payments.idRequest
      this.$engine.services.payments[method](2, 1000, 1, {idRequest: this.idRequest})
      .then(resp => {
        if (that._isDestroyed) {
          return
        }
        if (!(resp && resp.data && resp.data.payments && resp.data.payments.length)) {
          that.details = {}
          that.activateSpinner = false
          return
        }
        // if auto refresh is running and the call is for autoRefresh, show spinner
        if (resp.data.payments[0].status !== that.details.status && autoRefresh) {
          that.activateSpinner = true
          // if the new status is a definitive status, stop the auto refresh
          if (that.idRefresh && !['1','5','13','15'].includes(that.details.status)) {
            clearTimeout(that.idRefresh)
          }
        }
        // check status to keep going on refresh
        if (['1','5','13','15'].includes(resp.data.payments[0].status)) {
          that.detailsAutoRefresh()
        }
        // if status didnt change, do not refresh details
        if (resp.data.payments[0].status === that.details.status && autoRefresh) {
          return
        }
        // if history length changed, refresh it
        if (that.details && that.details.history && resp.data.payments.length && resp.data.payments[0].history && resp.data.payments[0].history.length &&
            that.details.history.length !== resp.data.payments[0].history.length) {
          that.details.history = resp.data.history
        }
        that.details = resp.data.payments[0]
        if (that.details && that.details.format && that.details.format.request) {
          that.fileFormat = that.details.format.request
        }
        that.standard = that.details.standard
        that.originalInstallements = that.details.installments
        that.originalDate = that.details.requestedExecutionDate
        that.originalAmount = that.details.amount
        that.originalReason = that.details.reason
        //Changer format dates exec + installments à l'arrivée des détails (pour format DD/MM/YYYY HH:mm:ss pour datetime-picker-custom)
        if (that.details.direction === '0' && that.isSRTP &&  ['5'].includes(resp.data.payments[0].status) && that.showAcceptModifyDate()) {
          if (!that.details.installments.length) {
            that.details.requestedExecutionDate = moment(that.details.requestedExecutionDate).format('DD/MM/YYYY HH:mm:ss')
          } else {
            that.details.installments.forEach((installment, index) => {
              installment.Date = moment(installment.Date).format('DD/MM/YYYY HH:mm:ss')
            })
          }
        }
        that.activateSpinner = false
        if (that.isHRTP) {
          // for HRTP, bank account is defined by the creditor
          that.debtorBankAccount = that.details.debtorBankAccount
          that.details.requestedExpirationDate = that.getExpirationDate(that.details)
        }
        if(that.canSeePaymentDetails) {
          that.getPayments()
        }
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    seeXml (data, service, action, recordId = null) {
      let that = this
      let id = data.id
      let type = data.type ? data.type : 'Technical_Body'
      if (recordId !== null && data.technicalBody === '1') {
        id = recordId
        type = 'Technical_Body'
      }
      let xmlDetails = {}
      this.$engine.services.payments
        .getXml(service, type, id)
        .then((resp) => {
          if (resp.data) {
            xmlDetails = resp.data
            xmlDetails.type = type
            if (action === 'see') {
              that.$bus.emit('popup-xml-details', xmlDetails)
            } else {
              //download file
              let extension = '.xml'
              let message = that.$i18n.t('common.xml_downloaded')
              if (that.isDataJSON(resp.data.data)) {
                extension = '.json'
                message = that.$i18n.t('common.json_downloaded')
              }
              const fileName = moment().format('YYYYMMDD_hhmmss_') + type + extension
              downloadFileWithDefinedHeaders(that, fileName, resp.data.data)
              that.$f7.alert('', message)
            }
          }
        })
        .catch((error) => {
          errorMessageAlert(error, that)
        })
    },
    showAcceptModifyAmount () {
      return (
        this.details.direction === '0' &&
        this.details.acceptModifyAmount === '1' &&
        (this.details.status === '5' || (this.details.status === '1' && this.details.standard === '1'))
      )
    },
    showAcceptModifyAmountCreditor () {
      return (
        this.details.direction === '1' &&
        this.details.acceptModifyAmount === '1' &&
        (this.details.status === '5' || (this.details.status === '1' && this.details.standard === '1'))
      )
    },
    showAcceptModifyAmountValided () {
      return (
        this.details.amountResponse &&
        this.details.amountResponse !== this.details.amount
      )
    },
    showAcceptModifyDate () {
      return (
        this.details.direction === '0' &&
        this.details.acceptModifyExecutionDate === '1' &&
        (this.details.status === '5' || this.details.status === '1')
      )
    },
    showAcceptModifyDateCreditor () {
      return (
        this.details.direction === '1' &&
        this.details.acceptModifyExecutionDate === '1' &&
        (this.details.status === '5' || this.details.status === '1')
      )
    },
    showAcceptModifyInstallmentValidated () {
      return (
        this.details.originalInstallments.length > 0 &&
        (this.details.acceptedRequestedExecutionDatetime !== this.details.requestedExecutionDate || this.details.amountResponse !== this.details.amount)
      )
    },
    showAcceptModifyDateValidated () {
      return (
        this.details.acceptedRequestedExecutionDatetime &&
        this.details.acceptedRequestedExecutionDatetime !== this.details.requestedExecutionDate &&
        (!this.details.installments.length || (this.details.installments.length && this.details.installments[this.details.installments.length - 1].Date !== this.details.acceptedRequestedExecutionDatetime))
      )
    },
    showAcceptModifyReason () {
      return (
        this.details.direction === '0' &&
        this.details.acceptModifyRemittanceInformation === '1' &&
        this.details.status === '5'
      )
    },
    showAcceptModifyReasonCreditor () {
      return (
        this.details.direction === '1' &&
        this.details.acceptModifyRemittanceInformation === '1' &&
        this.details.status === '5'
      )
    },
    showAcceptModifyReasonValidated () {
      return (
        "acceptedRemittanceInformation" in this.details &&
        this.details.acceptModifyRemittanceInformation === '1' &&
        this.details.acceptedRemittanceInformation !== this.details.reason &&
        this.details.status !== '5'
      )
    },
    showInstantPayment (iban) {
      const code = iban.substring(4, 9)
      if (!bankDatas.Banks.find((e) => e.code === code)) {
        return false
      }
      const instantPayment = bankDatas.Banks.find((e) => e.code === code).sctinst
      return instantPayment
    },
    showOtherDebtors () {
      return this.details.IdGroup
    },
    showPain001View (record) {
      return (
        record.status === status.ORDER_GENERATED ||
        record.status === status.INST_ORDER_GENERATED
      )
    },
    showPaymentAxepta () {
      this.payStatus = '1'
      /* Remplacer reason par la ref de la facture */
      const amount =
        this.$settings.clickedMessage.amount !== ''
          ? this.$settings.clickedMessage.amount
          : this.details.amount
      this.$bus.$emit('popup-payment-axepta', {
        amount: amount,
        currency: this.details.currency,
        description: this.details.reason,
        ref: this.details.reason,
        selectScreen: true,
        transId: this.details.endToEndId,
      })
    },
    transactionAccepted () {
      let that = this

      this.Dom7('input').addClass('display-error')
      this.Dom7('input').focus()
      this.Dom7('button').focus()
      this.Dom7('input').removeClass('display-error')

      this.amountError = false
      this.dateExecError = false
      if (
        this.details.acceptModifyAmount !== '0' &&
        (this.details.amount === '' || parseInt(this.details.amount) <= 0) &&
        (this.details.creditNoteAmount === '' || parseInt(this.details.creditNoteAmount) <= 0)
      ) {
        if (this.details.standard === '1') {
          this.payStatus = '0'
          this.debtorBankAccount = ''
        }
        this.amountError = true
        this.amountErrorMessage = this.$i18n.t('errors.invld_amnt')
        this.$f7.alert('', this.$t('errors.invld_amnt'))
        return
      }

      if ((this.standard === '2' ? !parseInt(this.details.amount) : (!parseFloat(this.details.amount) && !parseFloat(this.details.creditNoteAmount)) )) {
        if (this.details.standard === '1') {
          this.payStatus = '0'
          this.debtorBankAccount = ''
        }
        this.amountError = true
        this.amountErrorMessage = this.$i18n.t('errors.invld_amnt')
        this.$f7.alert('', this.$t('errors.invld_amnt'))
        return
      }

      if (this.details.acceptModifyAmount !== '0' && this.standard === '2' && !Number.isInteger(parseFloat(this.details.amount))){
        if (this.details.standard === '1') {
          this.payStatus = '0'
          this.debtorBankAccount = ''
        }
        this.amountError = true
        this.amountErrorMessage = this.$i18n.t('errors.max_amt_cents')
        this.$f7.alert('', this.$t('errors.invld_amnt'))
        return
      }

      this.maxAmount = !this.settings.maxAmount ? (this.standard === '1' ? this.settings.SRTPmaxAmount : this.settings.HRTPmaxAmount) : this.settings.maxAmount
      if (parseFloat(this.details.amount) > parseFloat(this.maxAmount)){
        this.payStatus = '0'
        this.amountError = true
        this.amountErrorMessage = this.$i18n.t('errors.max_amt_authrsd', {maxAmount: that.maxAmount})
        this.$f7.alert('', this.$t('errors.invld_amnt'))
        return
      }

      let TxStatus = '10'

      // boucle sur tous les instalments
      // pour chaque instalment, check si changement de date ou de montant par rapport à l'original
      // si oui, TxtStatus = ACWC
      // si date du dernier instalment a changé, changer aussi le requestedExecutionDate
      let installmentHasError = false
      this.hasInstallmentsChanged = false

      const today = moment().format('YYYY-MM-DD')

      this.details.installments.forEach((elem, index) => {
        if((elem.Amount === '' || parseFloat(elem.Amount) <= 0) && !installmentHasError){
          this.$f7.alert('', this.$t('errors.installment_sum_error'))
          installmentHasError = true
        }
        if((formatDateTime(elem.Date) === '' || moment(formatDateTime(elem.Date)).format('YYYY-MM-DD') < today) && !installmentHasError){
          this.$f7.alert('', this.$t('errors.installment_date'))
          this.dateExecError = true
          this.dateExecErrorMessage = this.$i18n.t('errors.invld_dt')
          installmentHasError = true
        }
        if(elem.Amount !== this.originalInstallements[index].Amount || formatDateTime(elem.Date) !== formatDateTime(this.originalInstallements[index].Date)) {
          if((moment(formatDateTime(elem.Date)).format('YYYY-MM-DD') < today) && !installmentHasError){
            this.$f7.alert('', this.$t('errors.installment_date'))
            installmentHasError = true
            return
          }
          that.hasInstallmentsChanged = true
          if (that.details.installments.length === (index + 1)) { // c'est le dernier
            if(formatDateTime(elem.Date) !== formatDateTime(this.originalInstallements[index].Date)){
              that.details.requestedExecutionDate = formatDateTime(elem.Date)
            }
          }
        }
      })

      if (installmentHasError) {
        if (this.details.standard === '1') {
          this.payStatus = '0'
          this.debtorBankAccount = ''
        }
        return
      }

      if (this.details.acceptModifyExecutionDate === '1' &&
        (this.details.requestedExecutionDate === '' || moment(formatDateTime(this.details.requestedExecutionDate)).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD') || (!this.details.requestedExecutionDate.match(/^([0-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/[0-9]{4} ([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/) && !this.details.installments.length))) {
        if (this.details.standard === '1') {
          this.payStatus = '0'
          this.debtorBankAccount = ''
        }
        this.$f7.alert('', this.$t('errors.invld_dt'))
        return
      }


      // si jamais on reçoit une date au lieu d'un datetime il faut la comparer proprement et set le bon timezone
      let offset = new Date().getTimezoneOffset()
      let tz = `${offset <= 0 ? '+' : '-'}${String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0')}:${String(Math.abs(offset) % 60).padStart(2, '0')}`
      let correctedOriginalExecutionDate  = that.originalDate.length > 10 ? that.originalDate : that.originalDate + 'T00:00:00.000' + tz
      let correctedRequestedExecutionDate  = formatDateTime(this.details.requestedExecutionDate) ? formatDateTime(this.details.requestedExecutionDate) : formatDateTime(this.details.requestedExecutionDate + 'T00:00:00.000' + tz)
      if (this.details.requestedExecutionDate && this.details.amount && (this.details.reason || this.details.reason === "")) {
        if (correctedOriginalExecutionDate !== correctedRequestedExecutionDate && this.details.acceptModifyExecutionDate === '1') {
          that.hasOriginalDateChanged = true
          TxStatus = '9'
        }
        if(this.originalAmount !== this.details.amount && this.details.acceptModifyAmount) {
          that.hasOriginalAmountChanged = true
          TxStatus = '9'
        }
        if (this.originalReason !== this.details.reason && this.details.acceptModifyRemittanceInformation) {
          TxStatus = '9'
        }
        if(this.hasInstallmentsChanged) {
          TxStatus = '9'
        }
      }


      this.action = 'accept'
      this.ImmPmtAccepted = 'true'
      this.answerToPayments(TxStatus, {
        comment: '',
        isToGenerateXML: this.$engine.settings.get(1).isToGenerateXML
      })
    },
    transactionAcceptedAndPay () {
      let that = this

      if (!this.debtorBankAccount && !this.details.debtorBankAccount) {
        this.$bus.$emit('popup-choice-bank-account', {})
        return
      }
      if (this.isHRTP) {
        this.$f7.modal({
          title: that.$i18n.t('common.accpt_hrtp'),
          text: that.$i18n.t('common.action_question'),
          buttons: [{
            text: that.$t('administration.no'),
            onClick: that.$f7.closeModal()
          }, {
            text: that.$t('administration.yes'),
            onClick: function () {
              if (that.payStatus !== '1') {
                that.payStatus = '1'
              }
              if (that.details.status === '9' || that.details.status === '10') {
                that.pay()
              } else {
                that.transactionAccepted()
              }
            }
          }]
        })
      } else {
        if (this.payStatus !== '1') {
          this.payStatus = '1'
        }
        if (this.details.status === '9' || this.details.status === '10') {
          this.pay()
        } else {
          this.transactionAccepted()
        }
      }
    },
    transactionRefused () {
      this.$bus.$emit('popup-choice-payment-refuse', this.details.standard)
    },
    viewXML () {
      let that = this
      this.$f7.showPreloader(that.$i18n.t('common.opnng_fl'))
      this.$engine.services
        .getXMLDetail('payment', 'pain001', that.details.id)
        .then((response) => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({
            type: {
              data: response.data,
            },
          })
          /* TLV 22/09/2020
           * Lignes ci-dessous a decommenter quand on testera le telechargement de
           * fichiers sur mobile */
          /* if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              typeMessage + '_' + idMessage + '.xml',
              response.data.data,
              response.data.data.split('')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else { */ // browser
          /* let blob = base64url.decode(response.data['envelopes'][0].message)
          const linkSource = 'data:text/csvcharset:utf-8,' + blob */
          let blob = b64toBlob(response.data.data.split(',')[1], 'text/xml')
          let linkSource = window.URL.createObjectURL(blob)
          let fileLink = document.createElement('a')
          fileLink.href = linkSource
          let today = moment().format()
          fileLink.setAttribute('download', 'Technical_View' + today + '.xml') // or any other extension
          fileLink.click()
          // }
        })
        .catch((error) => {
          that.$f7.hidePreloader()
        })
    },
    waitingForAnswerRTP (requestStatus) {
      return (
        requestStatus === status.RECEIVED || requestStatus === status.WAITING
      )
    },
    writeToFile (fileName, data, fileType, readonly, success, error) {
      /* eslint-disable no-undef */
      let that = this
      let directory = ''

      if (readonly) {
        if (this.$f7.device.os === 'android') {
          directory = cordova.file.externalDataDirectory
        } else if (this.$f7.device.os === 'ios') {
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        this.saveFileToDirectory(
          fileName,
          data,
          fileType,
          directory,
          success,
          error
        )
      } else {
        if (this.$f7.device.os === 'android') {
          directory = cordova.file.externalRootDirectory
        } else if (this.$f7.device.os === 'ios') {
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        try {
          this.checkForWritePermissions(
            function () {
              try {
                window.resolveLocalFileSystemURL(
                  directory,
                  function (directoryEntry) {
                    directoryEntry.getDirectory(
                      'Download',
                      { create: true },
                      function (downloadDir, _data) {
                        that.saveFileToDirectory(
                          fileName,
                          data,
                          fileType,
                          downloadDir.nativeURL,
                          function (filePath, fileType) {
                          },
                          function (error, _data) {
                            alert('Unable to save file: ' + error.code)
                          }
                        )
                      },
                      function (error, _data) {
                        alert(
                          'Unable to get/create download directory: ' +
                            error.code
                        )
                      }
                    )
                  },
                  (e, file) => {
                    // error resolveLocalFileSystemURL
                  }
                )
              } catch (error) {
                // get dir
                console.error(error)
              }
            },
            function () {
              alert(
                'App needs access to the phone\'s file storage in order to save files.'
              )
            }
          )
        } catch (error) {
          // get perms
          console.error(error)
        }
      }
      /* eslint-enable no-undef */
    },
    zoneCodeToSign () {
      let curr = currencySymbol(this.details.currency)
      return curr
    }
  }
}
</script>
